
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("3jH64", function(module, exports) {
//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

(function(global, factory) {
    factory((parcelRequire("45fvw")));
})(module.exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split('_'),
        weekdaysShort: "s\xf8._ma._ti._on._to._fr._l\xf8.".split('_'),
        weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: "[i g\xe5r kl.] LT",
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: "\xe9n time",
            hh: '%d timer',
            d: "\xe9n dag",
            dd: '%d dager',
            w: "\xe9n uke",
            ww: '%d uker',
            M: "\xe9n m\xe5ned",
            MM: "%d m\xe5neder",
            y: "ett \xe5r",
            yy: "%d \xe5r"
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    return nb;
});

});


var $45fvw = parcelRequire("45fvw");

var $45fvw = parcelRequire("45fvw");
function $d7fcaaa29d0ffaa7$var$toLevelModel(level) {
    const shiftMinutes = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).duration(level.shiftedTime.diff(level.time)).asMinutes();
    return {
        flag: level.flag == 'low' ? "Fj\xe6re" : 'Flo',
        time: level.time,
        timeDisplayText: level.time.format("HH:mm"),
        add: '' + Math.floor(shiftMinutes / 60) + ':' + shiftMinutes % 60,
        shiftedTime: level.shiftedTime,
        shiftedTimeDisplayText: level.shiftedTime.format("HH:mm"),
        level: Math.round(level.value),
        diff: Math.round(level.diff),
        utcOffsetDiff: level.utcOffsetDiff
    };
}
function $d7fcaaa29d0ffaa7$var$cap1stLetter(s) {
    return s[0].toUpperCase() + s.substr(1);
}
function $d7fcaaa29d0ffaa7$var$getDayDisplayText(day, now) {
    var prefix = $d7fcaaa29d0ffaa7$var$cap1stLetter(day.format("dddd "));
    var postFix = "";
    if (now.isSame(day, 'day')) prefix = "I dag ";
    if (new (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(now).add(1, 'days').isSame(day, 'day')) prefix = "I morgen ";
    if (!now.isSame(day, 'year')) postFix = day.format(" yyyy");
    return prefix + day.format("D. MMMM") + postFix;
}
function $d7fcaaa29d0ffaa7$var$toDayModels(shiftedLevels, now) {
    let dayLevel = null;
    let daylevels = [];
    let day = null;
    for(let i = 0; i < shiftedLevels.length; i++){
        const time = shiftedLevels[i].shiftedTime;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(time).startOf('day').isSame(day)) {
            day = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(time).startOf('day');
            dayLevel = {
                day: day,
                dayDisplayText: $d7fcaaa29d0ffaa7$var$getDayDisplayText(day, now),
                levels: [
                    $d7fcaaa29d0ffaa7$var$toLevelModel(shiftedLevels[i])
                ]
            };
            daylevels.push(dayLevel);
        } else dayLevel.levels.push($d7fcaaa29d0ffaa7$var$toLevelModel(shiftedLevels[i], shiftedLevels[i - 1]));
    }
    return daylevels;
}
var $d7fcaaa29d0ffaa7$export$2e2bcd8739ae039 = $d7fcaaa29d0ffaa7$var$toDayModels;



var $45fvw = parcelRequire("45fvw");
function $470ca43ad33fe47d$var$GetMoonPhaseByDay(day) {
    const hit = $470ca43ad33fe47d$var$MoonPhases.filter((m)=>m.time.isSame(day, 'day'));
    if (hit.length > 0) return hit[0].phase;
    else return undefined;
}
function $470ca43ad33fe47d$var$createMomentFromDateTimeData(y, m, d, h, mi, s) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))([
        y,
        m - 1,
        d,
        h,
        mi,
        s
    ]); // moment month is zero based
}
const $470ca43ad33fe47d$var$MoonPhases = [
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 6, 9, 17, 43, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 6, 16, 14, 5, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 6, 24, 11, 2, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 7, 2, 2, 19, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 7, 8, 20, 23, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 7, 16, 1, 24, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 7, 24, 4, 3, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 7, 31, 10, 42, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 8, 7, 2, 2, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 8, 14, 14, 53, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 8, 22, 19, 31, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 8, 29, 18, 35, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 9, 5, 9, 54, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 9, 13, 6, 41, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 9, 21, 8, 59, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 9, 28, 2, 50, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 10, 4, 21, 6, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 10, 13, 0, 5, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 10, 20, 20, 31, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 10, 27, 12, 5, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 11, 3, 12, 23, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 11, 11, 17, 47, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 11, 19, 6, 27, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 11, 25, 22, 44, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 12, 3, 7, 40, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 12, 11, 10, 29, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 12, 18, 15, 14, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2015, 12, 25, 11, 11, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 1, 2, 5, 30, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 1, 10, 1, 30, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 1, 16, 23, 26, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 1, 24, 1, 45, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 2, 1, 3, 27, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 2, 8, 14, 38, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 2, 15, 7, 46, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 2, 22, 18, 19, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 3, 1, 23, 10, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 3, 9, 1, 54, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 3, 15, 17, 2, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 3, 23, 12, 0, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 3, 31, 15, 16, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 4, 7, 11, 23, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 4, 14, 3, 59, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 4, 22, 5, 23, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 4, 30, 3, 28, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 5, 6, 19, 29, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 5, 13, 17, 2, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 5, 21, 21, 14, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 5, 29, 12, 11, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 6, 5, 2, 59, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 6, 12, 8, 9, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 6, 20, 11, 2, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 6, 27, 18, 18, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 7, 4, 11, 0, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 7, 12, 0, 51, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 7, 19, 22, 56, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 7, 26, 22, 59, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 8, 2, 20, 44, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 8, 10, 18, 20, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 8, 18, 9, 26, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 8, 25, 3, 40, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 9, 1, 9, 3, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 9, 9, 11, 48, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 9, 16, 19, 5, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 9, 23, 9, 56, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 10, 1, 0, 11, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 10, 9, 4, 32, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 10, 16, 4, 23, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 10, 22, 19, 13, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 10, 30, 17, 38, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 11, 7, 19, 51, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 11, 14, 13, 52, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 11, 21, 8, 33, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 11, 29, 12, 18, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 12, 7, 9, 3, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 12, 14, 0, 5, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 12, 21, 1, 55, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2016, 12, 29, 6, 53, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 1, 5, 19, 47, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 1, 12, 11, 33, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 1, 19, 22, 13, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 1, 28, 0, 7, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 2, 4, 4, 18, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 2, 11, 0, 32, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 2, 18, 19, 33, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 2, 26, 14, 58, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 3, 5, 11, 32, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 3, 12, 14, 53, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 3, 20, 15, 58, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 3, 28, 2, 57, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 4, 3, 18, 39, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 4, 11, 6, 8, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 4, 19, 9, 56, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 4, 26, 12, 16, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 5, 3, 2, 46, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 5, 10, 21, 42, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 5, 19, 0, 32, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 5, 25, 19, 44, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 6, 1, 12, 42, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 6, 9, 13, 9, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 6, 17, 11, 32, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 6, 24, 2, 30, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 7, 1, 0, 51, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 7, 9, 4, 6, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 7, 16, 19, 25, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 7, 23, 9, 45, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 7, 30, 15, 23, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 8, 7, 18, 10, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 8, 15, 1, 15, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 8, 21, 18, 30, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 8, 29, 8, 12, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 9, 6, 7, 2, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 9, 13, 6, 25, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 9, 20, 5, 29, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 9, 28, 2, 53, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 10, 5, 18, 40, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 10, 12, 12, 25, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 10, 19, 19, 12, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 10, 27, 22, 22, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 11, 4, 5, 22, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 11, 10, 20, 36, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 11, 18, 11, 42, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 11, 26, 17, 2, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 12, 3, 15, 46, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 12, 10, 7, 51, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 12, 18, 6, 30, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2017, 12, 26, 9, 20, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 1, 2, 2, 24, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 1, 8, 22, 25, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 1, 17, 2, 17, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 1, 24, 22, 20, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 1, 31, 13, 26, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 2, 7, 15, 53, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 2, 15, 21, 5, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 2, 23, 8, 9, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 3, 2, 0, 51, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 3, 9, 11, 19, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 3, 17, 13, 11, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 3, 24, 15, 35, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 3, 31, 12, 36, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 4, 8, 7, 17, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 4, 16, 1, 57, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 4, 22, 21, 45, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 4, 30, 0, 58, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 5, 8, 2, 8, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 5, 15, 11, 47, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 5, 22, 3, 49, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 5, 29, 14, 19, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 6, 6, 18, 31, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 6, 13, 19, 43, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 6, 20, 10, 50, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 6, 28, 4, 52, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 7, 6, 7, 50, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 7, 13, 2, 47, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 7, 19, 19, 52, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 7, 27, 20, 20, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 8, 4, 18, 17, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 8, 11, 9, 57, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 8, 18, 7, 48, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 8, 26, 11, 56, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 9, 3, 2, 37, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 9, 9, 18, 1, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 9, 16, 23, 14, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 9, 25, 2, 52, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 10, 2, 9, 45, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 10, 9, 3, 46, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 10, 16, 18, 1, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 10, 24, 16, 45, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 10, 31, 16, 40, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 11, 7, 16, 2, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 11, 15, 14, 54, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 11, 23, 5, 39, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 11, 30, 0, 18, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 12, 7, 7, 20, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 12, 15, 11, 49, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 12, 22, 17, 48, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2018, 12, 29, 9, 34, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 1, 6, 1, 28, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 1, 14, 6, 45, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 1, 21, 5, 16, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 1, 27, 21, 10, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 2, 4, 21, 3, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 2, 12, 22, 26, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 2, 19, 15, 53, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 2, 26, 11, 27, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 3, 6, 16, 3, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 3, 14, 10, 27, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 3, 21, 1, 42, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 3, 28, 4, 9, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 4, 5, 8, 50, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 4, 12, 19, 5, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 4, 19, 11, 12, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 4, 26, 22, 18, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 5, 4, 22, 45, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 5, 12, 1, 12, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 5, 18, 21, 11, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 5, 26, 16, 33, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 6, 3, 10, 1, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 6, 10, 5, 59, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 6, 17, 8, 30, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 6, 25, 9, 46, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 7, 2, 19, 16, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 7, 9, 10, 54, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 7, 16, 21, 38, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 7, 25, 1, 17, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 8, 1, 3, 11, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 8, 7, 17, 30, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 8, 15, 12, 29, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 8, 23, 14, 56, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 8, 30, 10, 37, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 9, 6, 3, 10, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 9, 14, 4, 32, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 9, 22, 2, 40, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 9, 28, 18, 26, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 10, 5, 16, 47, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 10, 13, 21, 7, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 10, 21, 12, 39, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 10, 28, 3, 38, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 11, 4, 10, 23, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 11, 12, 13, 34, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 11, 19, 21, 10, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 11, 26, 15, 5, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 12, 4, 6, 58, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 12, 12, 5, 12, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 12, 19, 4, 57, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2019, 12, 26, 5, 13, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 1, 3, 4, 45, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 1, 10, 19, 21, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 1, 17, 12, 58, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 1, 24, 21, 41, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 2, 2, 1, 41, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 2, 9, 7, 33, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 2, 15, 22, 17, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 2, 23, 15, 31, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 3, 2, 19, 57, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 3, 9, 17, 47, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 3, 16, 9, 34, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 3, 24, 9, 28, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 4, 1, 10, 21, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 4, 8, 2, 35, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 4, 14, 22, 56, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 4, 23, 2, 25, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 4, 30, 20, 38, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 5, 7, 10, 45, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 5, 14, 14, 2, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 5, 22, 17, 38, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 5, 30, 3, 29, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 6, 5, 19, 12, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 6, 13, 6, 23, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 6, 21, 6, 41, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 6, 28, 8, 15, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 7, 5, 4, 44, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 7, 12, 23, 28, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 7, 20, 17, 32, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 7, 27, 12, 32, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 8, 3, 15, 58, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 8, 11, 16, 44, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 8, 19, 2, 41, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 8, 25, 17, 57, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 9, 2, 5, 22, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 9, 10, 9, 25, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 9, 17, 11, 0, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 9, 24, 1, 54, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 10, 1, 21, 5, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 10, 10, 0, 39, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 10, 16, 19, 31, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 10, 23, 13, 22, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 10, 31, 14, 49, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 11, 8, 13, 46, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 11, 15, 5, 7, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 11, 22, 4, 44, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 11, 30, 9, 29, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 12, 8, 0, 36, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 12, 14, 16, 16, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 12, 21, 23, 41, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2020, 12, 30, 3, 28, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 1, 6, 9, 37, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 1, 13, 5, 0, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 1, 20, 21, 1, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 1, 28, 19, 16, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 2, 4, 17, 37, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 2, 11, 19, 5, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 2, 19, 18, 47, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 2, 27, 8, 17, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 3, 6, 1, 30, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 3, 13, 10, 21, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 3, 21, 14, 40, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 3, 28, 18, 48, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 4, 4, 10, 2, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 4, 12, 2, 30, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 4, 20, 6, 58, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 4, 27, 3, 31, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 5, 3, 19, 50, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 5, 11, 18, 59, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 5, 19, 19, 12, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 5, 26, 11, 13, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 6, 2, 7, 24, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 6, 10, 10, 52, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 6, 18, 3, 54, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 6, 24, 18, 39, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 7, 1, 21, 10, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 7, 10, 1, 16, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 7, 17, 10, 10, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 7, 24, 2, 36, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 7, 31, 13, 15, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 8, 8, 13, 50, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 8, 15, 15, 19, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 8, 22, 12, 1, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 8, 30, 7, 13, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 9, 7, 0, 51, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 9, 13, 20, 39, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 9, 20, 23, 54, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 9, 29, 1, 57, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 10, 6, 11, 5, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 10, 13, 3, 25, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 10, 20, 14, 56, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 10, 28, 20, 5, 7),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 11, 4, 21, 14, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 11, 11, 12, 45, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 11, 19, 8, 57, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 11, 27, 12, 27, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 12, 4, 7, 42, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 12, 11, 1, 35, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 12, 19, 4, 35, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2021, 12, 27, 2, 23, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 1, 2, 18, 33, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 1, 9, 18, 11, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 1, 17, 23, 48, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 1, 25, 13, 40, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 2, 1, 5, 45, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 2, 8, 13, 50, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 2, 16, 16, 56, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 2, 23, 22, 32, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 3, 2, 17, 34, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 3, 10, 10, 45, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 3, 18, 7, 17, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 3, 25, 5, 37, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 4, 1, 6, 24, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 4, 9, 6, 47, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 4, 16, 18, 54, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 4, 23, 11, 56, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 4, 30, 20, 28, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 5, 9, 0, 21, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 5, 16, 4, 14, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 5, 22, 18, 43, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 5, 30, 11, 30, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 6, 7, 14, 48, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 6, 14, 11, 51, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 6, 21, 3, 10, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 6, 29, 2, 52, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 7, 7, 2, 14, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 7, 13, 18, 37, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 7, 20, 14, 18, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 7, 28, 17, 54, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 8, 5, 11, 6, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 8, 12, 1, 35, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 8, 19, 4, 36, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 8, 27, 8, 17, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 9, 3, 18, 7, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 9, 10, 9, 58, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 9, 17, 21, 51, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 9, 25, 21, 54, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 10, 3, 0, 13, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 10, 9, 20, 54, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 10, 17, 17, 15, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 10, 25, 10, 48, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 11, 1, 6, 37, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 11, 8, 11, 2, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 11, 16, 13, 26, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 11, 23, 22, 57, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 11, 30, 14, 36, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 12, 8, 4, 8, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 12, 16, 8, 56, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 12, 23, 10, 16, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2022, 12, 30, 1, 20, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 1, 6, 23, 7, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 1, 15, 2, 10, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 1, 21, 20, 53, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 1, 28, 15, 18, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 2, 5, 18, 28, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 2, 13, 16, 0, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 2, 20, 7, 5, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 2, 27, 8, 5, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 3, 7, 12, 40, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 3, 15, 2, 8, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 3, 21, 17, 23, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 3, 29, 2, 32, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 4, 6, 4, 34, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 4, 13, 9, 11, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 4, 20, 4, 12, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 4, 27, 21, 19, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 5, 5, 17, 33, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 5, 12, 14, 28, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 5, 19, 15, 53, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 5, 27, 15, 22, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 6, 4, 3, 41, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 6, 10, 19, 31, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 6, 18, 4, 37, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 6, 26, 7, 49, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 7, 3, 11, 38, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 7, 10, 1, 47, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 7, 17, 18, 31, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 7, 25, 22, 6, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 8, 1, 18, 31, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 8, 8, 10, 28, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 8, 16, 9, 38, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 8, 24, 9, 57, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 8, 31, 1, 35, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 9, 6, 22, 21, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 9, 15, 1, 39, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 9, 22, 19, 31, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 9, 29, 9, 57, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 10, 6, 13, 47, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 10, 14, 17, 55, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 10, 22, 3, 29, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 10, 28, 20, 23, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 11, 5, 8, 36, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 11, 13, 9, 27, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 11, 20, 10, 49, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 11, 27, 9, 16, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 12, 5, 5, 49, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 12, 12, 23, 31, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 12, 19, 18, 39, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2023, 12, 27, 0, 33, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 1, 4, 3, 30, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 1, 11, 11, 57, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 1, 18, 3, 52, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 1, 25, 17, 53, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 2, 2, 23, 17, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 2, 9, 22, 59, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 2, 16, 15, 0, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 2, 24, 12, 30, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 3, 3, 15, 23, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 3, 10, 9, 0, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 3, 17, 4, 10, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 3, 25, 7, 0, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 4, 2, 3, 14, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 4, 8, 18, 20, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 4, 15, 19, 13, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 4, 23, 23, 48, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 5, 1, 11, 27, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 5, 8, 3, 21, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 5, 15, 11, 47, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 5, 23, 13, 53, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 5, 30, 17, 12, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 6, 6, 12, 37, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 6, 14, 5, 18, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 6, 22, 1, 7, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 6, 28, 21, 53, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 7, 5, 22, 57, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 7, 13, 22, 48, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 7, 21, 10, 17, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 7, 28, 2, 51, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 8, 4, 11, 12, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 8, 12, 15, 18, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 8, 19, 18, 25, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 8, 26, 9, 25, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 9, 3, 1, 55, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 9, 11, 6, 5, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 9, 18, 2, 34, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 9, 24, 18, 49, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 10, 2, 18, 49, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 10, 10, 18, 55, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 10, 17, 11, 26, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 10, 24, 8, 2, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 11, 1, 12, 47, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 11, 9, 5, 55, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 11, 15, 21, 28, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 11, 23, 1, 27, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 12, 1, 6, 21, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 12, 8, 15, 26, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 12, 15, 9, 1, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 12, 22, 22, 18, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2024, 12, 30, 22, 26, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 1, 6, 23, 56, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 1, 13, 22, 26, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 1, 21, 20, 30, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 1, 29, 12, 35, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 2, 5, 8, 2, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 2, 12, 13, 53, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 2, 20, 17, 32, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 2, 28, 0, 44, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 3, 6, 16, 31, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 3, 14, 6, 54, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 3, 22, 11, 29, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 3, 29, 10, 57, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 4, 5, 2, 14, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 4, 13, 0, 22, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 4, 21, 1, 35, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 4, 27, 19, 31, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 5, 4, 13, 51, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 5, 12, 16, 55, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 5, 20, 11, 58, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 5, 27, 3, 2, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 6, 3, 3, 40, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 6, 11, 7, 43, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 6, 18, 19, 18, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 6, 25, 10, 31, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 7, 2, 19, 30, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 7, 10, 20, 36, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 7, 18, 0, 37, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 7, 24, 19, 11, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 8, 1, 12, 41, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 8, 9, 7, 54, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 8, 16, 5, 12, 7),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 8, 23, 6, 6, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 8, 31, 6, 25, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 9, 7, 18, 8, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 9, 14, 10, 32, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 9, 21, 19, 54, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 9, 29, 23, 53, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 10, 7, 3, 47, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 10, 13, 18, 12, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 10, 21, 12, 25, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 10, 29, 16, 20, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 11, 5, 13, 19, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 11, 12, 5, 28, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 11, 20, 6, 47, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 11, 28, 6, 58, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 12, 4, 23, 13, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 12, 11, 20, 51, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 12, 20, 1, 43, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2025, 12, 27, 19, 9, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 1, 3, 10, 2, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 1, 10, 15, 48, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 1, 18, 19, 51, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 1, 26, 4, 47, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 2, 1, 22, 9, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 2, 9, 12, 43, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 2, 17, 12, 1, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 2, 24, 12, 27, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 3, 3, 11, 37, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 3, 11, 9, 38, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 3, 19, 1, 23, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 3, 25, 19, 17, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 4, 2, 2, 11, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 4, 10, 4, 51, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 4, 17, 11, 51, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 4, 24, 2, 31, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 5, 1, 17, 23, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 5, 9, 21, 10, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 5, 16, 20, 0, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 5, 23, 11, 10, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 5, 31, 8, 45, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 6, 8, 10, 0, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 6, 15, 2, 54, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 6, 21, 21, 55, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 6, 29, 23, 56, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 7, 7, 19, 28, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 7, 14, 9, 43, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 7, 21, 11, 5, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 7, 29, 14, 35, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 8, 6, 2, 21, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 8, 12, 17, 36, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 8, 20, 2, 46, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 8, 28, 4, 18, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 9, 4, 7, 51, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 9, 11, 3, 26, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 9, 18, 20, 43, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 9, 26, 16, 48, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 10, 3, 13, 24, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 10, 10, 15, 49, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 10, 18, 16, 12, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 10, 26, 4, 11, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 11, 1, 20, 28, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 11, 9, 7, 2, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 11, 17, 11, 47, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 11, 24, 14, 53, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 12, 1, 6, 8, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 12, 9, 0, 51, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 12, 17, 5, 42, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 12, 24, 1, 28, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2026, 12, 30, 18, 59, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 1, 7, 20, 24, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 1, 15, 20, 34, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 1, 22, 12, 17, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 1, 29, 10, 55, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 2, 6, 15, 55, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 2, 14, 7, 58, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 2, 20, 23, 23, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 2, 28, 5, 16, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 3, 8, 9, 29, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 3, 15, 16, 25, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 3, 22, 10, 43, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 3, 30, 0, 53, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 4, 6, 23, 51, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 4, 13, 22, 56, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 4, 20, 22, 27, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 4, 28, 20, 17, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 5, 6, 10, 58, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 5, 13, 4, 43, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 5, 20, 10, 58, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 5, 28, 13, 57, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 6, 4, 19, 40, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 6, 11, 10, 55, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 6, 19, 0, 44, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 6, 27, 4, 54, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 7, 4, 3, 1, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 7, 10, 18, 38, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 7, 18, 15, 44, 45),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 7, 26, 16, 54, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 8, 2, 10, 5, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 8, 9, 4, 54, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 8, 17, 7, 28, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 8, 25, 2, 27, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 8, 31, 17, 41, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 9, 7, 18, 31, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 9, 15, 23, 3, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 9, 23, 10, 20, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 9, 30, 2, 35, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 10, 7, 11, 47, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 10, 15, 13, 46, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 10, 22, 17, 29, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 10, 29, 13, 36, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 11, 6, 7, 59, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 11, 14, 3, 25, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 11, 21, 0, 48, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 11, 28, 3, 24, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 12, 6, 5, 22, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 12, 13, 16, 8, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 12, 20, 9, 10, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2027, 12, 27, 20, 12, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 1, 5, 1, 40, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 1, 12, 4, 2, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 1, 18, 19, 25, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 1, 26, 15, 12, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 2, 3, 19, 10, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 2, 10, 15, 3, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 2, 17, 8, 7, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 2, 25, 10, 37, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 3, 4, 9, 2, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 3, 11, 1, 5, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 3, 17, 23, 22, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 3, 26, 4, 31, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 4, 2, 19, 15, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 4, 9, 10, 26, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 4, 16, 16, 36, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 4, 24, 19, 46, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 5, 2, 2, 25, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 5, 8, 19, 48, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 5, 16, 10, 42, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 5, 24, 8, 16, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 5, 31, 7, 36, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 6, 7, 6, 8, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 6, 15, 4, 27, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 6, 22, 18, 27, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 6, 29, 12, 10, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 7, 6, 18, 10, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 7, 14, 20, 56, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 7, 22, 3, 1, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 7, 28, 17, 39, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 8, 5, 8, 9, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 8, 13, 11, 45, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 8, 20, 10, 43, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 8, 27, 1, 35, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 9, 3, 23, 47, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 9, 12, 0, 45, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 9, 18, 18, 23, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 9, 25, 13, 9, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 10, 3, 16, 24, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 10, 11, 11, 56, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 10, 18, 2, 56, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 10, 25, 4, 53, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 11, 2, 9, 17, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 11, 9, 21, 25, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 11, 16, 13, 17, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 11, 24, 0, 14, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 12, 2, 1, 40, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 12, 9, 5, 38, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 12, 16, 2, 6, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 12, 23, 21, 44, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2028, 12, 31, 16, 48, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 1, 7, 13, 26, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 1, 14, 17, 24, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 1, 22, 19, 23, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 1, 30, 6, 3, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 2, 5, 21, 52, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 2, 13, 10, 31, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 2, 21, 15, 9, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 2, 28, 17, 10, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 3, 7, 7, 51, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 3, 15, 4, 19, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 3, 23, 7, 32, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 3, 30, 2, 26, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 4, 5, 19, 51, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 4, 13, 21, 40, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 4, 21, 19, 49, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 4, 28, 10, 36, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 5, 5, 9, 47, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 5, 13, 13, 41, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 5, 21, 4, 15, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 5, 27, 18, 37, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 6, 4, 1, 18, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 6, 12, 3, 50, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 6, 19, 9, 53, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 6, 26, 3, 22, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 7, 3, 17, 57, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 7, 11, 15, 50, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 7, 18, 14, 14, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 7, 25, 13, 35, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 8, 2, 11, 15, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 8, 10, 1, 55, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 8, 16, 18, 55, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 8, 24, 1, 51, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 9, 1, 4, 32, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 9, 8, 10, 44, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 9, 15, 1, 29, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 9, 22, 16, 29, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 9, 30, 20, 56, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 10, 7, 19, 14, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 10, 14, 11, 8, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 10, 22, 9, 27, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 10, 30, 11, 32, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 11, 6, 4, 23, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 11, 13, 0, 35, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 11, 21, 4, 2, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 11, 28, 23, 47, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 12, 5, 14, 51, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 12, 12, 17, 49, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 12, 20, 22, 46, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2029, 12, 28, 9, 48, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 1, 4, 2, 49, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 1, 11, 14, 5, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 1, 19, 15, 54, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 1, 26, 18, 14, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 2, 2, 16, 7, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 2, 10, 11, 49, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 2, 18, 6, 19, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 2, 25, 1, 57, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 3, 4, 6, 34, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 3, 12, 8, 47, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 3, 19, 17, 56, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 3, 26, 9, 51, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 4, 2, 22, 2, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 4, 11, 2, 56, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 4, 18, 3, 19, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 4, 24, 18, 38, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 5, 2, 14, 11, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 5, 10, 17, 11, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 5, 17, 11, 18, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 5, 24, 4, 57, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 6, 1, 6, 21, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 6, 9, 3, 35, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 6, 15, 18, 40, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 6, 22, 17, 19, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 6, 30, 21, 34, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 7, 8, 11, 1, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 7, 15, 2, 11, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 7, 22, 8, 7, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 7, 30, 11, 10, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 8, 6, 16, 42, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 8, 13, 10, 44, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 8, 21, 1, 15, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 8, 28, 23, 7, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 9, 4, 21, 55, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 9, 11, 21, 17, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 9, 19, 19, 56, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 9, 27, 9, 54, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 10, 4, 3, 55, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 10, 11, 10, 46, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 10, 19, 14, 50, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 10, 26, 20, 16, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 11, 2, 11, 55, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 11, 10, 3, 30, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 11, 18, 8, 32, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 11, 25, 6, 46, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 12, 1, 22, 56, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 12, 9, 22, 40, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 12, 18, 0, 1, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 12, 24, 17, 32, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2030, 12, 31, 13, 35, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 1, 8, 18, 25, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 1, 16, 12, 47, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 1, 23, 4, 30, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 1, 30, 7, 42, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 2, 7, 12, 46, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 2, 14, 22, 49, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 2, 21, 15, 48, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 3, 1, 4, 2, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 3, 9, 4, 29, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 3, 16, 6, 35, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 3, 23, 3, 48, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 3, 31, 0, 32, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 4, 7, 17, 21, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 4, 14, 12, 57, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 4, 21, 16, 56, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 4, 29, 19, 19, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 5, 7, 3, 39, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 5, 13, 19, 6, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 5, 21, 7, 16, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 5, 29, 11, 19, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 6, 5, 11, 58, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 6, 12, 2, 20, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 6, 19, 22, 24, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 6, 28, 0, 18, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 7, 4, 19, 1, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 7, 11, 11, 49, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 7, 19, 13, 40, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 7, 27, 10, 34, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 8, 3, 1, 45, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 8, 10, 0, 23, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 8, 18, 4, 32, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 8, 25, 18, 39, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 9, 1, 9, 20, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 9, 8, 16, 14, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 9, 16, 18, 46, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 9, 24, 1, 19, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 9, 30, 18, 57, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 10, 8, 10, 50, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 10, 16, 8, 20, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 10, 23, 7, 36, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 10, 30, 7, 32, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 11, 7, 7, 2, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 11, 14, 21, 9, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 11, 21, 14, 44, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 11, 28, 23, 18, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 12, 7, 3, 19, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 12, 14, 9, 5, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 12, 21, 0, 0, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2031, 12, 28, 17, 32, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 1, 5, 22, 3, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 1, 12, 20, 6, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 1, 19, 12, 14, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 1, 27, 12, 52, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 2, 4, 13, 48, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 2, 11, 6, 24, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 2, 18, 3, 28, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 2, 26, 7, 43, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 3, 5, 1, 46, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 3, 11, 16, 24, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 3, 18, 20, 56, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 3, 27, 0, 46, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 4, 3, 10, 10, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 4, 10, 2, 39, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 4, 17, 15, 24, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 4, 25, 15, 9, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 5, 2, 16, 1, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 5, 9, 13, 35, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 5, 17, 9, 43, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 5, 25, 2, 36, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 5, 31, 20, 50, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 6, 8, 1, 31, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 6, 16, 2, 59, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 6, 23, 11, 32, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 6, 30, 2, 11, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 7, 7, 14, 41, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 7, 15, 18, 31, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 7, 22, 18, 51, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 7, 29, 9, 25, 7),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 8, 6, 5, 11, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 8, 14, 7, 50, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 8, 21, 1, 46, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 8, 27, 19, 33, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 9, 4, 20, 56, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 9, 12, 18, 48, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 9, 19, 9, 30, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 9, 26, 9, 12, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 10, 4, 13, 26, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 10, 12, 3, 47, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 10, 18, 18, 57, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 10, 26, 2, 28, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 11, 3, 5, 44, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 11, 10, 11, 33, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 11, 17, 6, 41, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 11, 24, 22, 47, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 12, 2, 20, 52, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 12, 9, 19, 8, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 12, 16, 20, 48, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2032, 12, 24, 20, 38, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 1, 1, 10, 16, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 1, 8, 3, 34, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 1, 15, 13, 6, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 1, 23, 17, 45, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 1, 30, 21, 59, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 2, 6, 13, 33, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 2, 14, 7, 3, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 2, 22, 11, 52, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 3, 1, 8, 23, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 3, 8, 1, 26, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 3, 16, 1, 37, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 3, 24, 1, 49, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 3, 30, 17, 51, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 4, 6, 15, 13, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 4, 14, 19, 17, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 4, 22, 11, 42, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 4, 29, 2, 45, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 5, 6, 6, 45, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 5, 14, 10, 42, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 5, 21, 18, 28, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 5, 28, 11, 36, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 6, 4, 23, 38, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 6, 12, 23, 18, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 6, 19, 23, 29, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 6, 26, 21, 6, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 7, 4, 17, 11, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 7, 12, 9, 28, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 7, 19, 4, 6, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 7, 26, 8, 12, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 8, 3, 10, 25, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 8, 10, 18, 7, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 8, 17, 9, 42, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 8, 24, 21, 39, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 9, 2, 2, 23, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 9, 9, 2, 20, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 9, 15, 17, 33, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 9, 23, 13, 39, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 10, 1, 16, 32, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 10, 8, 10, 57, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 10, 15, 4, 47, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 10, 23, 7, 28, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 10, 31, 4, 46, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 11, 6, 20, 31, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 11, 13, 20, 8, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 11, 22, 1, 38, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 11, 29, 15, 14, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 12, 6, 7, 21, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 12, 13, 15, 27, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 12, 21, 18, 46, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2033, 12, 29, 0, 19, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 1, 4, 19, 46, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 1, 12, 13, 16, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 1, 20, 10, 1, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 1, 27, 8, 31, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 2, 3, 10, 4, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 2, 11, 11, 8, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 2, 18, 23, 9, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 2, 25, 16, 33, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 3, 5, 2, 9, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 3, 13, 6, 44, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 3, 20, 10, 14, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 3, 27, 1, 18, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 4, 3, 19, 18, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 4, 11, 22, 44, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 4, 18, 19, 25, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 4, 25, 11, 34, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 5, 3, 12, 15, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 5, 11, 10, 55, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 5, 18, 3, 12, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 5, 24, 23, 57, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 6, 2, 3, 53, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 6, 9, 19, 43, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 6, 16, 10, 25, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 6, 23, 14, 34, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 7, 1, 17, 44, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 7, 9, 1, 58, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 7, 15, 18, 14, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 7, 23, 7, 4, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 7, 31, 5, 54, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 8, 7, 6, 50, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 8, 14, 3, 52, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 8, 22, 0, 43, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 8, 29, 16, 49, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 9, 5, 11, 41, 7),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 9, 12, 16, 13, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 9, 20, 18, 39, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 9, 28, 2, 56, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 10, 4, 18, 4, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 10, 12, 7, 32, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 10, 20, 12, 2, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 10, 27, 12, 42, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 11, 3, 3, 27, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 11, 11, 1, 15, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 11, 19, 4, 1, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 11, 25, 22, 31, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 12, 2, 16, 46, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 12, 10, 20, 14, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 12, 18, 17, 44, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2034, 12, 25, 8, 54, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 1, 1, 10, 0, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 1, 9, 15, 2, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 1, 17, 4, 45, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 1, 23, 20, 16, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 1, 31, 6, 2, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 2, 8, 8, 21, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 2, 15, 13, 16, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 2, 22, 8, 53, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 3, 2, 3, 0, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 3, 9, 23, 9, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 3, 16, 20, 14, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 3, 23, 22, 41, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 3, 31, 23, 6, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 4, 8, 10, 57, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 4, 15, 2, 54, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 4, 22, 13, 20, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 4, 30, 16, 53, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 5, 7, 20, 3, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 5, 14, 10, 28, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 5, 22, 4, 25, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 5, 30, 7, 30, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 6, 6, 3, 20, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 6, 12, 19, 49, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 6, 20, 19, 37, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 6, 28, 18, 42, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 7, 5, 9, 59, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 7, 12, 7, 32, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 7, 20, 10, 36, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 7, 28, 2, 55, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 8, 3, 17, 11, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 8, 10, 21, 52, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 8, 19, 1, 0, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 8, 26, 9, 7, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 9, 2, 1, 59, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 9, 9, 14, 46, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 9, 17, 14, 23, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 9, 24, 14, 39, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 10, 1, 13, 6, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 10, 9, 9, 49, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 10, 17, 2, 35, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 10, 23, 20, 56, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 10, 31, 2, 58, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 11, 8, 5, 50, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 11, 15, 13, 48, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 11, 22, 5, 16, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 11, 29, 19, 37, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 12, 8, 1, 4, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 12, 15, 0, 32, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 12, 21, 16, 28, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2035, 12, 29, 14, 30, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 1, 6, 17, 47, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 1, 13, 11, 15, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 1, 20, 6, 46, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 1, 28, 10, 16, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 2, 5, 7, 0, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 2, 11, 22, 8, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 2, 18, 23, 46, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 2, 27, 4, 58, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 3, 5, 16, 48, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 3, 12, 9, 9, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 3, 19, 18, 38, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 3, 27, 20, 56, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 4, 4, 0, 3, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 4, 10, 20, 22, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 4, 18, 14, 5, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 4, 26, 9, 32, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 5, 3, 5, 54, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 5, 10, 8, 9, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 5, 18, 8, 39, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 5, 25, 19, 16, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 6, 1, 11, 34, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 6, 8, 21, 1, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 6, 17, 1, 2, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 6, 24, 3, 9, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 6, 30, 18, 12, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 7, 8, 11, 18, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 7, 16, 14, 39, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 7, 23, 10, 16, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 7, 30, 2, 56, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 8, 7, 2, 48, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 8, 15, 1, 35, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 8, 21, 17, 35, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 8, 28, 14, 43, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 9, 5, 18, 45, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 9, 13, 10, 28, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 9, 20, 1, 51, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 9, 27, 6, 12, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 10, 5, 10, 14, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 10, 12, 18, 9, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 10, 19, 11, 49, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 10, 27, 1, 13, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 11, 4, 0, 43, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 11, 11, 1, 28, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 11, 18, 0, 14, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 11, 25, 22, 27, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 12, 3, 14, 8, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 12, 10, 9, 18, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 12, 17, 15, 34, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2036, 12, 25, 19, 44, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 1, 2, 2, 34, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 1, 8, 18, 28, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 1, 16, 9, 34, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 1, 24, 14, 54, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 1, 31, 14, 3, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 2, 7, 5, 43, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 2, 15, 4, 53, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 2, 23, 6, 40, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 3, 2, 0, 27, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 3, 8, 19, 24, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 3, 16, 23, 35, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 3, 24, 18, 39, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 3, 31, 9, 53, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 4, 7, 11, 24, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 4, 15, 16, 7, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 4, 23, 3, 11, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 4, 29, 18, 53, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 5, 7, 4, 55, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 5, 15, 5, 54, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 5, 22, 9, 8, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 5, 29, 4, 23, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 6, 5, 22, 48, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 6, 13, 17, 9, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 6, 20, 13, 45, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 6, 27, 15, 19, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 7, 5, 16, 0, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 7, 13, 2, 31, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 7, 19, 18, 30, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 7, 27, 4, 14, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 8, 4, 7, 50, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 8, 11, 10, 41, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 8, 18, 0, 59, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 8, 25, 19, 9, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 9, 2, 22, 2, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 9, 9, 18, 25, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 9, 16, 10, 35, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 9, 24, 11, 31, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 10, 2, 10, 28, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 10, 9, 2, 34, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 10, 16, 0, 15, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 10, 24, 4, 36, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 10, 31, 21, 6, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 11, 7, 12, 2, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 11, 14, 17, 58, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 11, 22, 21, 34, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 11, 30, 6, 6, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 12, 6, 23, 38, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 12, 14, 14, 41, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 12, 22, 13, 38, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2037, 12, 29, 14, 4, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 1, 5, 13, 41, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 1, 13, 12, 33, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 1, 21, 3, 59, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 1, 27, 22, 0, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 2, 4, 5, 51, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 2, 12, 9, 29, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 2, 19, 16, 9, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 2, 26, 6, 55, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 3, 5, 23, 14, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 3, 14, 3, 41, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 3, 21, 2, 9, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 3, 27, 17, 35, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 4, 4, 16, 42, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 4, 12, 18, 1, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 4, 19, 10, 35, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 4, 26, 6, 14, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 5, 4, 9, 19, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 5, 12, 4, 17, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 5, 18, 18, 23, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 5, 25, 20, 43, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 6, 3, 0, 23, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 6, 10, 11, 11, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 6, 17, 2, 30, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 6, 24, 12, 39, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 7, 2, 13, 31, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 7, 9, 16, 0, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 7, 16, 11, 47, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 7, 24, 5, 39, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 8, 1, 0, 39, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 8, 7, 20, 21, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 8, 14, 22, 56, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 8, 22, 23, 11, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 8, 30, 10, 12, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 9, 6, 1, 50, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 9, 13, 12, 24, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 9, 21, 16, 26, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 9, 28, 18, 57, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 10, 5, 9, 51, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 10, 13, 4, 21, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 10, 21, 8, 23, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 10, 28, 3, 52, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 11, 3, 21, 23, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 11, 11, 22, 26, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 11, 19, 22, 9, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 11, 26, 13, 46, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 12, 3, 12, 45, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 12, 11, 17, 30, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 12, 19, 9, 28, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2038, 12, 26, 1, 1, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 1, 2, 7, 36, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 1, 10, 11, 45, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 1, 17, 18, 41, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 1, 24, 13, 35, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 2, 1, 4, 44, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 2, 9, 3, 38, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 2, 16, 2, 35, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 2, 23, 3, 17, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 3, 3, 2, 14, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 3, 10, 16, 34, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 3, 17, 10, 7, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 3, 24, 17, 59, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 4, 1, 21, 54, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 4, 9, 2, 52, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 4, 15, 18, 6, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 4, 23, 9, 34, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 5, 1, 14, 6, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 5, 8, 11, 19, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 5, 15, 3, 16, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 5, 23, 1, 37, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 5, 31, 2, 24, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 6, 6, 18, 47, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 6, 13, 14, 16, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 6, 21, 17, 21, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 6, 29, 11, 16, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 7, 6, 2, 3, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 7, 13, 3, 37, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 7, 21, 7, 53, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 7, 28, 17, 49, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 8, 4, 9, 56, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 8, 11, 19, 35, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 8, 19, 20, 50, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 8, 26, 23, 16, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 9, 2, 19, 23, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 9, 10, 13, 45, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 9, 18, 8, 22, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 9, 25, 4, 52, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 10, 2, 7, 22, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 10, 10, 8, 59, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 10, 17, 19, 8, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 10, 24, 11, 50, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 10, 31, 22, 35, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 11, 9, 3, 45, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 11, 16, 5, 45, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 11, 22, 21, 16, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 11, 30, 16, 49, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 12, 8, 20, 44, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 12, 15, 16, 31, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 12, 22, 10, 1, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2039, 12, 30, 12, 37, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 1, 7, 11, 5, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 1, 14, 3, 24, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 1, 21, 2, 20, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 1, 29, 7, 54, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 2, 5, 22, 32, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 2, 12, 14, 24, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 2, 19, 21, 33, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 2, 28, 0, 59, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 3, 6, 7, 18, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 3, 13, 1, 45, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 3, 20, 17, 58, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 3, 28, 15, 11, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 4, 4, 14, 5, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 4, 11, 13, 59, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 4, 19, 13, 37, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 4, 27, 2, 37, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 5, 3, 19, 59, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 5, 11, 3, 27, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 5, 19, 7, 0, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 5, 26, 11, 46, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 6, 2, 2, 16, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 6, 9, 18, 2, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 6, 17, 21, 31, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 6, 24, 19, 18, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 7, 1, 10, 17, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 7, 9, 9, 14, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 7, 17, 9, 15, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 7, 24, 2, 5, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 7, 30, 21, 5, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 8, 8, 0, 25, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 8, 15, 18, 35, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 8, 22, 9, 9, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 8, 29, 11, 16, 7),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 9, 6, 15, 13, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 9, 14, 2, 7, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 9, 20, 17, 42, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 9, 28, 4, 41, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 10, 6, 5, 25, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 10, 13, 8, 40, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 10, 20, 4, 49, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 10, 28, 0, 26, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 11, 4, 18, 55, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 11, 11, 15, 22, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 11, 18, 19, 5, 45),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 11, 26, 21, 7, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 12, 4, 7, 32, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 12, 10, 23, 29, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 12, 18, 12, 15, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2040, 12, 26, 17, 2, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 1, 2, 19, 7, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 1, 9, 10, 5, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 1, 17, 7, 10, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 1, 25, 10, 32, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 2, 1, 5, 42, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 2, 7, 23, 39, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 2, 16, 2, 20, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 2, 24, 0, 28, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 3, 2, 15, 38, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 3, 9, 15, 50, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 3, 17, 20, 18, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 3, 25, 10, 31, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 4, 1, 1, 29, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 4, 8, 9, 38, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 4, 16, 12, 0, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 4, 23, 17, 23, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 4, 30, 11, 45, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 5, 8, 3, 53, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 5, 16, 0, 51, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 5, 22, 22, 25, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 5, 29, 22, 55, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 6, 6, 21, 40, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 6, 14, 10, 58, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 6, 21, 3, 11, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 6, 28, 11, 16, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 7, 6, 14, 12, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 7, 13, 19, 0, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 7, 20, 9, 12, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 7, 28, 1, 1, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 8, 5, 4, 52, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 8, 12, 2, 4, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 8, 18, 17, 42, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 8, 26, 16, 15, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 9, 3, 17, 18, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 9, 10, 9, 23, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 9, 17, 5, 32, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 9, 25, 8, 40, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 10, 3, 3, 32, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 10, 9, 18, 2, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 10, 16, 21, 4, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 10, 25, 1, 29, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 11, 1, 12, 4, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 11, 8, 4, 43, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 11, 15, 16, 5, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 11, 23, 17, 36, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 11, 30, 19, 48, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 12, 7, 17, 41, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 12, 15, 13, 32, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 12, 23, 8, 5, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2041, 12, 30, 3, 45, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 1, 6, 8, 53, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 1, 14, 11, 24, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 1, 21, 20, 41, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 1, 28, 12, 48, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 2, 5, 1, 57, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 2, 13, 7, 15, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 2, 20, 7, 38, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 2, 26, 23, 28, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 3, 6, 20, 9, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 3, 14, 23, 20, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 3, 21, 17, 22, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 3, 28, 11, 59, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 4, 5, 14, 15, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 4, 13, 11, 8, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 4, 20, 2, 18, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 4, 27, 2, 18, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 5, 5, 6, 48, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 5, 12, 19, 17, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 5, 19, 10, 54, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 5, 26, 18, 17, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 6, 3, 20, 47, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 6, 11, 0, 59, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 6, 17, 19, 47, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 6, 25, 11, 28, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 7, 3, 8, 8, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 7, 10, 5, 37, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 7, 17, 5, 51, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 7, 25, 5, 1, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 8, 1, 17, 32, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 8, 8, 10, 34, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 8, 15, 18, 0, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 8, 23, 21, 55, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 8, 31, 2, 1, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 9, 6, 17, 8, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 9, 14, 8, 49, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 9, 22, 13, 20, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 9, 29, 10, 33, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 10, 6, 2, 34, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 10, 14, 2, 2, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 10, 22, 2, 52, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 10, 28, 19, 47, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 11, 4, 15, 50, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 11, 12, 20, 27, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 11, 20, 14, 30, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 11, 27, 6, 5, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 12, 4, 9, 18, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 12, 12, 14, 29, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 12, 20, 0, 27, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2042, 12, 26, 17, 42, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 1, 3, 6, 7, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 1, 11, 6, 52, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 1, 18, 9, 4, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 1, 25, 6, 56, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 2, 2, 4, 14, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 2, 9, 21, 7, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 2, 16, 16, 59, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 2, 23, 21, 57, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 3, 4, 1, 6, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 3, 11, 9, 8, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 3, 18, 1, 2, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 3, 25, 14, 25, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 4, 2, 18, 55, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 4, 9, 19, 6, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 4, 16, 10, 8, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 4, 24, 7, 22, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 5, 2, 8, 58, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 5, 9, 3, 20, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 5, 15, 21, 4, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 5, 23, 23, 36, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 5, 31, 19, 24, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 6, 7, 10, 34, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 6, 14, 10, 18, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 6, 22, 14, 20, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 6, 30, 2, 52, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 7, 6, 17, 50, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 7, 14, 1, 46, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 7, 22, 3, 23, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 7, 29, 8, 22, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 8, 5, 2, 22, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 8, 12, 18, 56, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 8, 20, 15, 4, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 8, 27, 13, 8, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 9, 3, 13, 16, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 9, 11, 13, 0, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 9, 19, 1, 46, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 9, 25, 18, 39, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 10, 3, 3, 11, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 10, 11, 7, 4, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 10, 18, 11, 55, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 10, 25, 2, 27, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 11, 1, 19, 56, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 11, 10, 0, 12, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 11, 16, 21, 52, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 11, 23, 13, 45, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 12, 1, 14, 36, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 12, 9, 15, 27, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 12, 16, 8, 1, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 12, 23, 5, 3, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2043, 12, 31, 9, 47, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 1, 8, 4, 1, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 1, 14, 18, 50, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 1, 21, 23, 46, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 1, 30, 4, 4, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 2, 6, 13, 45, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 2, 13, 6, 41, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 2, 20, 20, 19, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 2, 28, 20, 11, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 3, 6, 21, 16, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 3, 13, 19, 40, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 3, 21, 16, 51, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 3, 29, 9, 25, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 4, 5, 3, 44, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 4, 12, 9, 38, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 4, 20, 11, 48, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 4, 27, 19, 41, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 5, 4, 10, 27, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 5, 12, 0, 16, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 5, 20, 4, 1, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 5, 27, 3, 39, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 6, 2, 18, 32, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 6, 10, 15, 15, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 6, 18, 16, 59, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 6, 25, 10, 23, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 7, 2, 4, 48, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 7, 10, 6, 21, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 7, 18, 2, 46, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 7, 24, 17, 9, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 7, 31, 17, 39, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 8, 8, 21, 13, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 8, 16, 10, 2, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 8, 23, 1, 5, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 8, 30, 9, 18, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 9, 7, 11, 23, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 9, 14, 15, 57, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 9, 21, 11, 2, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 9, 29, 3, 30, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 10, 7, 0, 29, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 10, 13, 21, 52, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 10, 20, 23, 35, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 10, 28, 23, 27, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 11, 5, 12, 26, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 11, 12, 5, 8, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 11, 19, 14, 57, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 11, 27, 19, 35, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 12, 4, 23, 33, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 12, 11, 14, 51, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 12, 19, 8, 52, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2044, 12, 27, 13, 59, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 1, 3, 10, 19, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 1, 10, 3, 31, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 1, 18, 4, 24, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 1, 26, 5, 8, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 2, 1, 21, 5, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 2, 8, 19, 2, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 2, 16, 23, 50, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 2, 24, 16, 36, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 3, 3, 7, 52, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 3, 10, 12, 49, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 3, 18, 17, 14, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 3, 26, 0, 55, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 4, 1, 18, 42, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 4, 9, 7, 51, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 4, 17, 7, 26, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 4, 24, 7, 11, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 5, 1, 5, 51, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 5, 9, 2, 50, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 5, 16, 18, 26, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 5, 23, 12, 37, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 5, 30, 17, 51, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 6, 7, 20, 22, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 6, 15, 3, 4, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 6, 21, 18, 28, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 6, 29, 7, 15, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 7, 7, 11, 30, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 7, 14, 10, 27, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 7, 21, 1, 51, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 7, 28, 22, 10, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 8, 5, 23, 56, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 8, 12, 17, 38, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 8, 19, 11, 54, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 8, 27, 14, 7, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 9, 4, 10, 2, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 9, 11, 1, 27, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 9, 18, 1, 29, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 9, 26, 6, 11, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 10, 3, 18, 31, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 10, 10, 10, 36, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 10, 17, 18, 54, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 10, 25, 21, 30, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 11, 2, 2, 9, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 11, 8, 21, 48, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 11, 16, 15, 25, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 11, 24, 11, 43, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 12, 1, 9, 45, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 12, 8, 11, 40, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 12, 16, 13, 7, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 12, 24, 0, 48, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2045, 12, 30, 18, 10, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 1, 7, 4, 23, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 1, 15, 9, 42, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 1, 22, 12, 50, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 1, 29, 4, 10, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 2, 5, 23, 9, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 2, 14, 3, 19, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 2, 20, 23, 43, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 2, 27, 16, 22, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 3, 7, 18, 14, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 3, 15, 17, 12, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 3, 22, 9, 26, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 3, 29, 6, 56, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 4, 6, 11, 51, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 4, 14, 3, 20, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 4, 20, 18, 20, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 4, 27, 23, 29, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 5, 6, 2, 55, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 5, 13, 10, 24, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 5, 20, 3, 14, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 5, 27, 17, 6, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 6, 4, 15, 21, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 6, 11, 15, 27, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 6, 18, 13, 9, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 6, 26, 10, 39, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 7, 4, 1, 38, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 7, 10, 19, 52, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 7, 18, 0, 54, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 7, 26, 3, 18, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 8, 2, 10, 24, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 8, 9, 1, 15, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 8, 16, 14, 49, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 8, 24, 18, 35, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 8, 31, 18, 24, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 9, 7, 9, 6, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 9, 15, 6, 38, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 9, 23, 8, 15, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 9, 30, 2, 24, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 10, 6, 20, 40, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 10, 14, 23, 40, 45),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 10, 22, 20, 7, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 10, 29, 11, 16, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 11, 5, 12, 28, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 11, 13, 17, 3, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 11, 21, 6, 9, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 11, 27, 21, 49, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 12, 5, 7, 55, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 12, 13, 9, 54, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 12, 20, 14, 42, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2046, 12, 27, 10, 38, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 1, 4, 5, 30, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 1, 12, 1, 20, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 1, 18, 22, 32, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 1, 26, 1, 43, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 2, 3, 3, 8, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 2, 10, 14, 39, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 2, 17, 6, 42, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 2, 24, 18, 25, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 3, 4, 22, 51, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 3, 12, 1, 36, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 3, 18, 16, 10, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 3, 26, 11, 43, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 4, 3, 15, 10, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 4, 10, 10, 34, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 4, 17, 3, 29, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 4, 25, 4, 39, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 5, 3, 3, 25, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 5, 9, 18, 23, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 5, 16, 16, 45, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 5, 24, 20, 26, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 6, 1, 11, 53, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 6, 8, 2, 4, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 6, 15, 7, 44, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 6, 23, 10, 35, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 6, 30, 17, 36, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 7, 7, 10, 33, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 7, 15, 0, 8, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 7, 22, 22, 48, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 7, 29, 22, 2, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 8, 5, 20, 37, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 8, 13, 17, 33, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 8, 21, 9, 15, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 8, 28, 2, 48, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 9, 4, 8, 53, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 9, 12, 11, 17, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 9, 19, 18, 30, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 9, 26, 9, 28, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 10, 3, 23, 41, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 10, 12, 4, 21, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 10, 19, 3, 27, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 10, 25, 19, 12, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 11, 2, 16, 57, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 11, 10, 19, 38, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 11, 17, 12, 58, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 11, 24, 8, 40, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 12, 2, 11, 54, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 12, 10, 8, 28, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 12, 16, 23, 37, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2047, 12, 24, 1, 50, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 1, 1, 6, 56, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 1, 8, 18, 48, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 1, 15, 11, 31, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 1, 22, 21, 55, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 1, 31, 0, 13, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 2, 7, 3, 16, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 2, 14, 0, 30, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 2, 21, 19, 21, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 2, 29, 14, 37, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 3, 7, 10, 44, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 3, 14, 14, 27, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 3, 22, 16, 2, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 3, 30, 2, 3, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 4, 5, 18, 9, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 4, 13, 5, 19, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 4, 21, 10, 1, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 4, 28, 11, 12, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 5, 5, 2, 21, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 5, 12, 20, 57, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 5, 21, 0, 15, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 5, 27, 18, 56, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 6, 3, 12, 4, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 6, 11, 12, 49, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 6, 19, 10, 48, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 6, 26, 2, 7, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 7, 2, 23, 57, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 7, 11, 4, 3, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 7, 18, 18, 31, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 7, 25, 9, 33, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 8, 1, 14, 29, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 8, 9, 17, 58, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 8, 17, 0, 31, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 8, 23, 18, 6, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 8, 31, 7, 41, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 9, 8, 6, 23, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 9, 15, 6, 3, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 9, 22, 4, 45, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 9, 30, 2, 44, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 10, 7, 17, 44, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 10, 14, 12, 19, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 10, 21, 18, 24, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 10, 29, 22, 13, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 11, 6, 4, 37, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 11, 12, 20, 28, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 11, 20, 11, 18, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 11, 28, 16, 32, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 12, 5, 15, 29, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 12, 12, 7, 28, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 12, 20, 6, 38, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2048, 12, 28, 8, 30, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 1, 4, 2, 23, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 1, 10, 21, 55, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 1, 19, 2, 28, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 1, 26, 21, 32, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 2, 2, 13, 15, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 2, 9, 15, 37, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 2, 17, 20, 46, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 2, 25, 7, 35, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 3, 4, 0, 10, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 3, 11, 11, 25, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 3, 19, 12, 22, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 3, 26, 15, 9, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 4, 2, 11, 38, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 4, 10, 7, 26, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 4, 18, 1, 4, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 4, 24, 21, 10, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 5, 2, 0, 10, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 5, 10, 1, 56, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 5, 17, 11, 13, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 5, 24, 2, 53, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 5, 31, 13, 59, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 6, 8, 17, 55, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 6, 15, 19, 26, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 6, 22, 9, 40, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 6, 30, 4, 49, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 7, 8, 7, 9, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 7, 15, 2, 28, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 7, 21, 18, 47, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 7, 29, 20, 6, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 8, 6, 17, 51, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 8, 13, 9, 18, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 8, 20, 7, 10, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 8, 28, 11, 17, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 9, 5, 2, 27, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 9, 11, 17, 3, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 9, 18, 23, 3, 7),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 9, 27, 2, 4, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 10, 4, 9, 38, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 10, 11, 2, 52, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 10, 18, 17, 54, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 10, 26, 16, 14, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 11, 2, 16, 18, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 11, 9, 15, 37, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 11, 17, 14, 31, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 11, 25, 5, 35, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 12, 1, 23, 39, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 12, 9, 7, 27, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 12, 17, 11, 14, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 12, 24, 17, 51, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2049, 12, 31, 8, 52, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 1, 8, 1, 38, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 1, 16, 6, 16, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 1, 23, 4, 56, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 1, 29, 20, 47, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 2, 6, 20, 46, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 2, 14, 22, 10, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 2, 21, 15, 2, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 2, 28, 11, 29, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 3, 8, 15, 22, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 3, 16, 10, 7, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 3, 23, 0, 40, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 3, 30, 4, 16, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 4, 7, 8, 11, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 4, 14, 18, 23, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 4, 21, 10, 25, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 4, 28, 22, 7, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 5, 6, 22, 25, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 5, 14, 0, 3, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 5, 20, 20, 50, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 5, 28, 16, 3, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 6, 5, 9, 50, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 6, 12, 4, 38, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 6, 19, 8, 21, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 6, 27, 9, 16, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 7, 4, 18, 50, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 7, 11, 9, 45, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 7, 18, 21, 16, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 7, 27, 1, 4, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 8, 3, 2, 19, 45),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 8, 9, 16, 47, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 8, 17, 11, 46, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 8, 25, 14, 55, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 9, 1, 9, 30, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 9, 8, 2, 50, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 9, 16, 3, 48, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 9, 24, 2, 33, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 9, 30, 17, 31, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 10, 7, 16, 31, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 10, 15, 20, 47, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 10, 23, 12, 9, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 10, 30, 3, 15, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 11, 6, 9, 56, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 11, 14, 13, 40, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 11, 21, 20, 24, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 11, 28, 15, 9, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 12, 6, 6, 26, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 12, 14, 5, 17, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 12, 21, 4, 14, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2050, 12, 28, 5, 14, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 1, 5, 4, 28, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 1, 12, 18, 57, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 1, 19, 12, 37, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 1, 26, 21, 19, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 2, 4, 1, 39, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 2, 11, 6, 40, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 2, 17, 22, 16, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 2, 25, 14, 52, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 3, 5, 19, 46, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 3, 12, 16, 51, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 3, 19, 9, 33, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 3, 27, 8, 59, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 4, 4, 9, 40, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 4, 11, 1, 58, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 4, 17, 22, 37, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 4, 26, 2, 18, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 5, 3, 19, 30, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 5, 10, 10, 28, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 5, 17, 13, 28, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 5, 25, 17, 34, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 6, 2, 2, 14, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 6, 8, 18, 55, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 6, 16, 5, 54, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 6, 24, 6, 13, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 7, 1, 7, 14, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 7, 8, 4, 8, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 7, 15, 23, 20, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 7, 23, 16, 35, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 7, 30, 11, 51, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 8, 6, 15, 4, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 8, 14, 16, 48, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 8, 22, 1, 34, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 8, 28, 17, 28, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 9, 5, 4, 32, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 9, 13, 9, 19, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 9, 20, 10, 10, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 9, 27, 1, 21, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 10, 4, 20, 46, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 10, 13, 0, 11, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 10, 19, 19, 12, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 10, 26, 12, 38, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 11, 3, 14, 58, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 11, 11, 13, 6, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 11, 18, 5, 5, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 11, 25, 4, 2, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 12, 3, 9, 36, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 12, 11, 0, 6, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 12, 17, 16, 4, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2051, 12, 24, 23, 20, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 1, 2, 3, 4, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 1, 9, 9, 26, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 1, 16, 4, 23, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 1, 23, 21, 2, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 1, 31, 18, 29, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 2, 7, 17, 35, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 2, 14, 18, 20, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 2, 22, 18, 44, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 3, 1, 7, 35, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 3, 8, 1, 16, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 3, 15, 9, 54, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 3, 23, 14, 8, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 3, 30, 18, 26, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 4, 6, 9, 27, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 4, 14, 2, 28, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 4, 22, 6, 2, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 4, 29, 3, 20, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 5, 5, 19, 4, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 5, 13, 18, 59, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 5, 21, 18, 14, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 5, 28, 10, 49, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 6, 4, 6, 48, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 6, 12, 10, 26, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 6, 20, 3, 9, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 6, 26, 17, 49, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 7, 3, 20, 58, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 7, 12, 0, 22, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 7, 19, 9, 37, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 7, 26, 1, 30, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 8, 2, 13, 19, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 8, 10, 12, 51, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 8, 17, 14, 42, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 8, 24, 11, 6, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 9, 1, 7, 9, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 9, 9, 0, 14, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 9, 15, 19, 47, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 9, 22, 23, 32, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 10, 1, 1, 35, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 10, 8, 10, 54, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 10, 15, 2, 21, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 10, 22, 15, 2, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 10, 30, 19, 38, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 11, 6, 21, 8, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 11, 13, 11, 49, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 11, 21, 9, 1, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 11, 29, 12, 15, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 12, 6, 7, 17, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 12, 13, 1, 6, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 12, 21, 4, 14, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2052, 12, 29, 2, 27, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 1, 4, 17, 45, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 1, 11, 18, 8, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 1, 19, 23, 11, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 1, 27, 13, 40, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 2, 3, 4, 57, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 2, 10, 13, 48, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 2, 18, 16, 30, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 2, 25, 22, 8, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 3, 4, 17, 8, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 3, 12, 10, 20, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 3, 20, 7, 10, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 3, 27, 4, 49, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 4, 3, 6, 22, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 4, 11, 6, 3, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 4, 18, 18, 47, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 4, 25, 11, 2, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 5, 2, 20, 24, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 5, 10, 23, 39, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 5, 18, 3, 42, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 5, 24, 18, 3, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 6, 1, 11, 1, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 6, 9, 14, 18, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 6, 16, 10, 50, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 6, 23, 2, 54, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 7, 1, 2, 0, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 7, 9, 1, 47, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 7, 15, 17, 25, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 7, 22, 14, 15, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 7, 30, 17, 5, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 8, 7, 10, 24, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 8, 14, 0, 40, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 8, 21, 4, 26, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 8, 29, 7, 52, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 9, 5, 17, 4, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 9, 12, 9, 35, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 9, 19, 21, 28, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 9, 27, 21, 49, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 10, 4, 23, 0, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 10, 11, 20, 53, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 10, 19, 16, 53, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 10, 27, 10, 37, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 11, 3, 5, 36, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 11, 10, 10, 54, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 11, 18, 13, 25, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 11, 25, 22, 20, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 12, 2, 14, 3, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 12, 10, 3, 39, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 12, 18, 9, 10, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2053, 12, 25, 9, 22, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 1, 1, 1, 10, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 1, 8, 22, 33, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 1, 17, 2, 14, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 1, 23, 20, 7, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 1, 30, 15, 7, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 2, 7, 18, 13, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 2, 15, 15, 35, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 2, 22, 6, 46, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 3, 1, 7, 35, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 3, 9, 12, 45, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 3, 17, 1, 20, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 3, 23, 17, 20, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 3, 31, 1, 49, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 4, 8, 4, 31, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 4, 15, 8, 23, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 4, 22, 4, 1, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 4, 29, 20, 45, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 5, 7, 17, 0, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 5, 14, 13, 56, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 5, 21, 15, 15, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 5, 29, 15, 2, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 6, 6, 2, 39, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 6, 12, 19, 16, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 6, 20, 3, 42, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 6, 28, 7, 29, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 7, 5, 10, 33, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 7, 12, 1, 36, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 7, 19, 17, 46, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 7, 27, 21, 27, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 8, 3, 17, 47, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 8, 10, 10, 5, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 8, 18, 9, 21, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 8, 26, 8, 55, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 9, 2, 1, 17, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 9, 8, 21, 46, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 9, 17, 1, 40, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 9, 24, 18, 25, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 10, 1, 9, 48, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 10, 8, 13, 19, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 10, 16, 17, 43, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 10, 24, 2, 39, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 10, 30, 20, 0, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 11, 7, 8, 33, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 11, 15, 8, 48, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 11, 22, 10, 22, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 11, 29, 8, 33, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 12, 7, 6, 6, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 12, 14, 22, 40, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 12, 21, 18, 21, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2054, 12, 28, 23, 51, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 1, 6, 3, 39, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 1, 13, 11, 20, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 1, 20, 3, 24, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 1, 27, 17, 38, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 2, 4, 22, 59, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 2, 11, 22, 47, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 2, 18, 14, 13, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 2, 26, 12, 38, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 3, 6, 14, 47, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 3, 13, 8, 56, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 3, 20, 3, 17, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 3, 28, 7, 0, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 4, 5, 2, 43, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 4, 11, 17, 57, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 4, 18, 18, 34, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 4, 26, 23, 16, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 5, 4, 11, 9, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 5, 11, 2, 31, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 5, 18, 11, 29, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 5, 26, 12, 56, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 6, 2, 17, 0, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 6, 9, 11, 35, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 6, 17, 5, 1, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 6, 25, 0, 15, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 7, 1, 21, 30, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 7, 8, 22, 10, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 7, 16, 22, 14, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 7, 24, 9, 47, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 7, 31, 2, 10, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 8, 7, 10, 56, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 8, 15, 14, 25, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 8, 22, 18, 14, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 8, 29, 8, 34, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 9, 6, 1, 55, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 9, 14, 5, 13, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 9, 21, 2, 19, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 9, 27, 18, 10, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 10, 5, 18, 37, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 10, 13, 18, 21, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 10, 20, 10, 48, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 10, 27, 7, 52, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 11, 4, 12, 11, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 11, 12, 5, 37, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 11, 18, 20, 33, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 11, 26, 1, 41, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 12, 4, 5, 39, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 12, 11, 15, 4, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 12, 18, 8, 14, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2055, 12, 25, 22, 28, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 1, 2, 22, 5, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 1, 9, 23, 13, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 1, 16, 22, 10, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 1, 24, 20, 20, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 2, 1, 12, 35, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 2, 8, 7, 0, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 2, 15, 13, 59, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 2, 23, 17, 11, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 3, 2, 0, 39, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 3, 8, 15, 30, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 3, 16, 6, 51, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 3, 24, 11, 16, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 3, 31, 10, 24, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 4, 7, 1, 32, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 4, 14, 23, 49, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 4, 23, 1, 33, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 4, 29, 18, 30, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 5, 6, 13, 29, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 5, 14, 16, 5, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 5, 22, 11, 49, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 5, 29, 1, 57, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 6, 5, 3, 20, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 6, 13, 7, 3, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 6, 20, 18, 48, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 6, 27, 9, 47, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 7, 4, 18, 54, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 7, 12, 20, 19, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 7, 19, 23, 44, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 7, 26, 18, 53, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 8, 3, 11, 51, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 8, 11, 7, 47, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 8, 18, 4, 13, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 8, 25, 5, 59, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 9, 2, 5, 42, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 9, 9, 17, 46, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 9, 16, 9, 49, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 9, 23, 19, 33, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 10, 1, 23, 32, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 10, 9, 2, 59, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 10, 15, 17, 57, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 10, 23, 11, 45, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 10, 31, 16, 11, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 11, 7, 12, 20, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 11, 14, 5, 32, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 11, 22, 6, 10, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 11, 30, 6, 36, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 12, 6, 22, 30, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 12, 13, 20, 52, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 12, 22, 1, 33, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2056, 12, 29, 18, 21, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 1, 5, 9, 48, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 1, 12, 15, 33, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 1, 20, 20, 0, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 1, 28, 3, 43, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 2, 3, 22, 9, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 2, 11, 12, 24, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 2, 19, 11, 56, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 2, 26, 11, 29, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 3, 5, 11, 24, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 3, 13, 9, 34, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 3, 21, 0, 44, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 3, 27, 18, 38, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 4, 4, 1, 30, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 4, 12, 4, 58, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 4, 19, 10, 48, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 4, 26, 2, 5, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 5, 3, 16, 31, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 5, 11, 21, 6, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 5, 18, 19, 1, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 5, 25, 10, 39, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 6, 2, 8, 10, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 6, 10, 9, 29, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 6, 17, 2, 17, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 6, 23, 21, 7, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 7, 1, 23, 46, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 7, 9, 18, 37, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 7, 16, 9, 27, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 7, 23, 10, 8, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 7, 31, 14, 31, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 8, 8, 1, 29, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 8, 14, 17, 20, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 8, 22, 2, 1, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 8, 30, 3, 54, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 9, 6, 7, 17, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 9, 13, 2, 52, 45),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 9, 20, 20, 25, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 9, 28, 15, 59, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 10, 5, 13, 13, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 10, 12, 15, 0, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 10, 20, 16, 8, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 10, 28, 3, 18, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 11, 3, 20, 23, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 11, 11, 6, 23, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 11, 19, 11, 31, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 11, 26, 14, 21, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 12, 3, 5, 53, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 12, 11, 0, 45, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 12, 19, 5, 1, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2057, 12, 26, 1, 21, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 1, 1, 18, 29, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 1, 9, 20, 38, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 1, 17, 19, 42, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 1, 24, 12, 13, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 1, 31, 10, 27, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 2, 8, 15, 53, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 2, 16, 7, 15, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 2, 22, 22, 56, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 3, 2, 5, 9, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 3, 10, 8, 51, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 3, 17, 15, 55, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 3, 24, 9, 49, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 4, 1, 1, 2, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 4, 8, 22, 54, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 4, 15, 22, 26, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 4, 22, 21, 28, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 4, 30, 20, 17, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 5, 8, 10, 11, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 5, 15, 3, 57, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 5, 22, 10, 22, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 5, 30, 13, 32, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 6, 6, 19, 14, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 6, 13, 9, 50, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 6, 21, 0, 34, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 6, 29, 4, 12, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 7, 6, 2, 46, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 7, 12, 17, 27, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 7, 20, 15, 39, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 7, 28, 16, 18, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 8, 4, 9, 37, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 8, 11, 3, 59, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 8, 19, 7, 2, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 8, 27, 2, 9, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 9, 2, 16, 50, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 9, 9, 18, 6, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 9, 17, 22, 17, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 9, 25, 10, 13, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 10, 2, 1, 35, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 10, 9, 11, 40, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 10, 17, 13, 4, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 10, 24, 17, 15, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 10, 31, 12, 53, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 11, 8, 7, 46, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 11, 16, 3, 8, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 11, 23, 0, 15, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 11, 30, 3, 16, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 12, 8, 4, 50, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 12, 15, 16, 11, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 12, 22, 8, 26, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2058, 12, 29, 20, 24, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 1, 7, 1, 6, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 1, 14, 3, 56, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 1, 20, 18, 50, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 1, 28, 15, 10, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 2, 5, 18, 48, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 2, 12, 14, 26, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 2, 19, 7, 56, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 2, 27, 10, 5, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 3, 7, 8, 46, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 3, 14, 0, 4, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 3, 20, 23, 29, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 3, 29, 3, 47, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 4, 5, 18, 45, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 4, 12, 9, 28, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 4, 19, 16, 36, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 4, 27, 19, 16, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 5, 5, 1, 28, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 5, 11, 19, 14, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 5, 19, 10, 21, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 5, 27, 8, 3, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 6, 3, 6, 19, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 6, 10, 5, 56, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 6, 18, 3, 54, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 6, 25, 18, 12, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 7, 2, 10, 52, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 7, 9, 17, 58, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 7, 17, 20, 34, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 7, 25, 2, 23, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 7, 31, 16, 42, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 8, 8, 7, 37, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 8, 16, 11, 40, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 8, 23, 9, 41, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 8, 30, 1, 4, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 9, 6, 23, 0, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 9, 15, 0, 43, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 9, 21, 17, 18, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 9, 28, 12, 53, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 10, 6, 15, 49, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 10, 14, 11, 38, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 10, 21, 2, 14, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 10, 28, 4, 31, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 11, 5, 9, 10, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 11, 12, 20, 44, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 11, 19, 13, 8, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 11, 26, 23, 41, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 12, 5, 1, 48, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 12, 12, 4, 49, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 12, 19, 2, 11, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2059, 12, 26, 21, 16, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 1, 3, 16, 39, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 1, 10, 12, 51, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 1, 17, 17, 13, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 1, 25, 19, 13, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 2, 2, 5, 21, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 2, 8, 21, 40, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 2, 16, 9, 55, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 2, 24, 15, 5, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 3, 2, 16, 11, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 3, 9, 7, 51, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 3, 17, 3, 40, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 3, 25, 7, 7, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 4, 1, 1, 37, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 4, 7, 19, 41, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 4, 15, 21, 21, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 4, 23, 18, 52, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 4, 30, 10, 10, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 5, 7, 9, 19, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 5, 15, 13, 38, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 5, 23, 3, 0, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 5, 29, 18, 22, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 6, 6, 0, 43, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 6, 14, 3, 36, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 6, 21, 8, 43, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 6, 28, 2, 57, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 7, 5, 17, 37, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 7, 13, 15, 7, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 7, 20, 13, 23, 7),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 7, 27, 12, 49, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 8, 4, 11, 15, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 8, 12, 0, 50, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 8, 18, 18, 22, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 8, 26, 0, 55, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 9, 3, 4, 35, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 9, 10, 9, 43, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 9, 17, 0, 59, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 9, 24, 15, 52, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 10, 2, 20, 40, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 10, 9, 18, 40, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 10, 16, 10, 29, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 10, 24, 9, 25, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 11, 1, 10, 55, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 11, 8, 4, 16, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 11, 14, 23, 48, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 11, 23, 4, 15, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 11, 30, 23, 10, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 12, 7, 14, 47, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 12, 14, 17, 14, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 12, 22, 22, 38, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2060, 12, 30, 9, 28, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 1, 6, 2, 24, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 1, 13, 13, 57, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 1, 21, 15, 15, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 1, 28, 18, 9, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 2, 4, 15, 21, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 2, 12, 11, 51, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 2, 20, 5, 30, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 2, 27, 1, 50, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 3, 6, 5, 53, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 3, 14, 8, 30, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 3, 21, 17, 22, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 3, 28, 9, 25, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 4, 4, 21, 46, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 4, 13, 2, 9, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 4, 20, 3, 4, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 4, 26, 17, 54, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 5, 4, 14, 12, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 5, 12, 16, 9, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 5, 19, 11, 2, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 5, 26, 4, 11, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 6, 3, 6, 8, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 6, 11, 2, 41, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 6, 17, 18, 2, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 6, 24, 16, 53, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 7, 2, 20, 51, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 7, 10, 10, 22, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 7, 17, 1, 9, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 7, 24, 8, 4, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 8, 1, 10, 10, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 8, 8, 16, 8, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 8, 15, 9, 38, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 8, 23, 1, 17, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 8, 30, 22, 17, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 9, 6, 21, 11, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 9, 13, 20, 36, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 9, 21, 19, 44, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 9, 29, 9, 31, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 10, 6, 2, 56, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 10, 13, 10, 40, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 10, 21, 14, 23, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 10, 28, 20, 11, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 11, 4, 10, 52, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 11, 12, 3, 39, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 11, 20, 8, 10, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 11, 27, 6, 31, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 12, 3, 22, 11, 7),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 12, 11, 22, 31, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 12, 19, 23, 57, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2061, 12, 26, 16, 52, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 1, 2, 13, 20, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 1, 10, 17, 51, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 1, 18, 12, 50, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 1, 25, 3, 36, 45),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 2, 1, 7, 42, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 2, 9, 12, 9, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 2, 16, 22, 37, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 2, 23, 15, 7, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 3, 3, 3, 48, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 3, 11, 4, 12, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 3, 18, 5, 57, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 3, 25, 3, 34, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 4, 1, 23, 54, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 4, 9, 17, 16, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 4, 16, 12, 2, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 4, 23, 16, 56, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 5, 1, 18, 33, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 5, 9, 3, 22, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 5, 15, 18, 17, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 5, 23, 7, 2, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 5, 31, 10, 43, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 6, 7, 11, 11, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 6, 14, 1, 52, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 6, 21, 21, 42, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 6, 29, 23, 53, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 7, 6, 17, 52, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 7, 13, 11, 42, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 7, 21, 12, 46, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 7, 29, 10, 3, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 8, 5, 0, 39, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 8, 12, 0, 20, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 8, 20, 3, 54, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 8, 27, 17, 48, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 9, 3, 8, 41, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 9, 10, 15, 59, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 9, 18, 18, 35, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 9, 26, 0, 10, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 10, 2, 18, 49, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 10, 10, 10, 26, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 10, 18, 8, 17, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 10, 25, 6, 27, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 11, 1, 7, 32, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 11, 9, 6, 49, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 11, 16, 20, 47, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 11, 23, 13, 57, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 11, 30, 23, 0, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 12, 9, 3, 28, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 12, 16, 8, 16, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 12, 22, 23, 39, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2062, 12, 30, 16, 56, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 1, 7, 22, 15, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 1, 14, 19, 11, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 1, 21, 12, 4, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 1, 29, 12, 22, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 2, 6, 13, 36, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 2, 13, 5, 48, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 2, 20, 3, 6, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 2, 28, 7, 37, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 3, 8, 1, 5, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 3, 14, 16, 13, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 3, 21, 20, 15, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 3, 30, 0, 48, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 4, 6, 9, 17, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 4, 13, 2, 33, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 4, 20, 14, 41, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 4, 28, 14, 51, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 5, 5, 15, 19, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 5, 12, 13, 10, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 5, 20, 9, 15, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 5, 28, 1, 46, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 6, 3, 20, 27, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 6, 11, 0, 42, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 6, 19, 2, 42, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 6, 26, 10, 24, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 7, 3, 2, 0, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 7, 10, 13, 47, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 7, 18, 18, 4, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 7, 25, 17, 54, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 8, 1, 9, 9, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 8, 9, 4, 39, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 8, 17, 7, 0, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 8, 24, 1, 16, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 8, 30, 19, 3, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 9, 7, 20, 52, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 9, 15, 17, 43, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 9, 22, 9, 20, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 9, 29, 8, 38, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 10, 7, 13, 26, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 10, 15, 2, 48, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 10, 21, 18, 45, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 10, 29, 2, 12, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 11, 6, 5, 21, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 11, 13, 10, 56, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 11, 20, 6, 8, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 11, 27, 22, 58, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 12, 5, 20, 5, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 12, 12, 18, 49, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 12, 19, 20, 3, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2063, 12, 27, 20, 56, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 1, 4, 9, 30, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 1, 11, 3, 13, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 1, 18, 12, 36, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 1, 26, 17, 41, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 2, 2, 21, 36, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 2, 9, 12, 55, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 2, 17, 7, 2, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 2, 25, 11, 22, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 3, 3, 8, 18, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 3, 10, 0, 32, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 3, 18, 1, 44, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 3, 26, 1, 12, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 4, 1, 17, 39, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 4, 8, 14, 24, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 4, 16, 19, 1, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 4, 24, 11, 16, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 5, 1, 2, 7, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 5, 8, 6, 15, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 5, 16, 9, 54, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 5, 23, 18, 14, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 5, 30, 10, 35, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 6, 6, 23, 22, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 6, 14, 22, 19, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 6, 21, 23, 13, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 6, 28, 20, 8, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 7, 6, 16, 47, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 7, 14, 8, 45, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 7, 21, 3, 34, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 7, 28, 7, 39, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 8, 5, 9, 40, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 8, 12, 17, 48, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 8, 19, 8, 54, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 8, 26, 21, 34, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 9, 4, 1, 28, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 9, 11, 2, 10, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 9, 17, 16, 44, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 9, 25, 13, 37, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 10, 3, 15, 49, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 10, 10, 10, 33, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 10, 17, 4, 21, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 10, 25, 7, 4, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 11, 2, 4, 23, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 11, 8, 19, 44, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 11, 15, 20, 13, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 11, 24, 0, 57, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 12, 1, 14, 59, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 12, 8, 6, 28, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 12, 15, 15, 44, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 12, 23, 18, 13, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2064, 12, 30, 23, 49, 7),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 1, 6, 19, 14, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 1, 14, 13, 18, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 1, 22, 9, 52, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 1, 29, 7, 37, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 2, 5, 10, 1, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 2, 13, 10, 50, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 2, 20, 23, 10, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 2, 27, 15, 28, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 3, 7, 2, 14, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 3, 15, 6, 24, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 3, 22, 9, 55, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 3, 29, 0, 23, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 4, 5, 19, 0, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 4, 13, 22, 37, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 4, 20, 18, 35, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 4, 27, 11, 1, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 5, 5, 11, 29, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 5, 13, 10, 51, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 5, 20, 2, 4, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 5, 26, 23, 37, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 6, 4, 3, 4, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 6, 11, 19, 24, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 6, 18, 9, 27, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 6, 25, 14, 7, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 7, 3, 17, 15, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 7, 11, 1, 15, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 7, 17, 17, 44, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 7, 25, 6, 21, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 8, 2, 5, 45, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 8, 9, 5, 51, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 8, 16, 3, 44, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 8, 23, 23, 55, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 8, 31, 16, 38, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 9, 7, 10, 48, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 9, 14, 16, 4, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 9, 22, 18, 8, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 9, 30, 2, 23, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 10, 6, 17, 36, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 10, 14, 7, 3, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 10, 22, 11, 52, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 10, 29, 11, 47, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 11, 5, 3, 25, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 11, 13, 0, 36, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 11, 21, 3, 50, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 11, 27, 21, 39, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 12, 4, 16, 53, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 12, 12, 19, 51, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 12, 20, 17, 11, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2065, 12, 27, 8, 26, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 1, 3, 9, 55, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 1, 11, 15, 6, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 1, 19, 3, 47, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 1, 25, 20, 13, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 2, 2, 5, 43, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 2, 10, 8, 28, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 2, 17, 12, 13, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 2, 24, 8, 50, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 3, 4, 2, 47, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 3, 11, 22, 47, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 3, 18, 19, 24, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 3, 25, 22, 12, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 4, 2, 23, 8, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 4, 10, 10, 2, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 4, 17, 2, 22, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 4, 24, 12, 28, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 5, 2, 16, 56, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 5, 9, 18, 57, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 5, 16, 10, 0, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 5, 24, 3, 37, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 6, 1, 7, 12, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 6, 8, 2, 30, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 6, 14, 19, 9, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 6, 22, 19, 14, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 6, 30, 17, 58, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 7, 7, 9, 34, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 7, 14, 6, 37, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 7, 22, 10, 33, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 7, 30, 2, 0, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 8, 5, 16, 58, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 8, 12, 20, 58, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 8, 21, 0, 49, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 8, 28, 8, 24, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 9, 4, 1, 36, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 9, 11, 14, 15, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 9, 19, 13, 46, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 9, 26, 14, 18, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 10, 3, 12, 24, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 10, 11, 9, 42, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 10, 19, 1, 42, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 10, 25, 20, 51, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 11, 2, 2, 12, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 11, 10, 5, 44, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 11, 17, 13, 5, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 11, 24, 5, 9, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 12, 1, 19, 15, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 12, 10, 0, 37, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 12, 17, 0, 16, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 12, 23, 16, 6, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2066, 12, 31, 14, 40, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 1, 8, 17, 0, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 1, 15, 11, 16, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 1, 22, 6, 16, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 1, 30, 10, 29, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 2, 7, 6, 13, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 2, 13, 21, 56, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 2, 20, 23, 29, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 3, 1, 4, 41, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 3, 8, 16, 15, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 3, 15, 8, 28, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 3, 22, 18, 43, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 3, 30, 20, 7, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 4, 6, 23, 37, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 4, 13, 19, 23, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 4, 21, 14, 14, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 4, 29, 8, 39, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 5, 6, 5, 18, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 5, 13, 7, 20, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 5, 21, 8, 28, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 5, 28, 18, 41, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 6, 4, 10, 38, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 6, 11, 20, 40, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 6, 20, 0, 28, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 6, 27, 2, 51, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 7, 3, 17, 1, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 7, 11, 11, 15, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 7, 19, 13, 58, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 7, 26, 9, 58, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 8, 2, 1, 50, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 8, 10, 2, 36, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 8, 18, 1, 8, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 8, 24, 16, 56, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 8, 31, 14, 3, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 9, 8, 18, 8, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 9, 16, 10, 19, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 9, 23, 0, 53, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 9, 30, 6, 0, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 10, 8, 9, 27, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 10, 15, 18, 2, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 10, 22, 10, 55, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 10, 30, 1, 7, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 11, 7, 0, 13, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 11, 14, 1, 6, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 11, 20, 23, 49, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 11, 28, 22, 5, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 12, 6, 14, 4, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 12, 13, 8, 37, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 12, 20, 15, 40, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2067, 12, 28, 19, 9, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 1, 5, 2, 37, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 1, 11, 17, 46, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 1, 19, 9, 44, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 1, 27, 14, 26, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 2, 3, 13, 43, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 2, 10, 5, 19, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 2, 18, 4, 37, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 2, 26, 6, 24, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 3, 3, 23, 37, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 3, 10, 19, 25, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 3, 18, 22, 55, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 3, 26, 18, 20, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 4, 2, 8, 50, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 4, 9, 11, 32, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 4, 17, 15, 28, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 4, 25, 2, 29, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 5, 1, 18, 6, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 5, 9, 4, 46, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 5, 17, 5, 34, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 5, 24, 7, 59, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 5, 31, 4, 2, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 6, 7, 22, 20, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 6, 15, 16, 59, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 6, 22, 12, 24, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 6, 29, 15, 10, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 7, 7, 15, 30, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 7, 15, 2, 6, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 7, 21, 17, 21, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 7, 29, 3, 54, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 8, 6, 7, 37, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 8, 13, 9, 50, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 8, 20, 0, 15, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 8, 27, 18, 27, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 9, 4, 22, 3, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 9, 11, 17, 18, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 9, 18, 10, 15, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 9, 26, 10, 47, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 10, 4, 10, 22, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 10, 11, 1, 38, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 10, 17, 23, 59, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 10, 26, 4, 16, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 11, 2, 20, 37, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 11, 9, 11, 39, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 11, 16, 17, 32, 7),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 11, 24, 21, 41, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 12, 2, 5, 20, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 12, 8, 23, 41, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 12, 16, 14, 10, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 12, 24, 13, 43, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2068, 12, 31, 13, 22, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 1, 7, 13, 42, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 1, 15, 12, 15, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 1, 23, 3, 35, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 1, 29, 21, 38, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 2, 6, 5, 28, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 2, 14, 9, 26, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 2, 21, 15, 16, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 2, 28, 6, 53, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 3, 7, 22, 34, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 3, 16, 3, 30, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 3, 23, 1, 12, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 3, 29, 17, 34, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 4, 6, 16, 12, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 4, 14, 17, 20, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 4, 21, 9, 57, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 4, 28, 5, 55, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 5, 6, 9, 10, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 5, 14, 3, 9, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 5, 20, 18, 5, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 5, 27, 20, 8, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 6, 5, 0, 18, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 6, 12, 9, 55, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 6, 19, 2, 13, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 6, 26, 12, 8, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 7, 4, 13, 4, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 7, 11, 14, 58, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 7, 18, 11, 12, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 7, 26, 5, 29, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 8, 2, 23, 43, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 8, 9, 19, 40, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 8, 16, 22, 2, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 8, 24, 23, 16, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 9, 1, 9, 5, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 9, 8, 1, 21, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 9, 15, 11, 34, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 9, 23, 16, 22, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 9, 30, 18, 8, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 10, 7, 9, 19, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 10, 15, 4, 2, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 10, 23, 7, 56, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 10, 30, 3, 34, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 11, 5, 20, 39, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 11, 13, 22, 37, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 11, 21, 21, 31, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 11, 28, 13, 45, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 12, 5, 12, 2, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 12, 13, 17, 37, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 12, 21, 8, 59, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2069, 12, 28, 0, 49, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 1, 4, 7, 15, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 1, 12, 11, 21, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 1, 19, 18, 30, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 1, 26, 12, 58, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 2, 3, 4, 45, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 2, 11, 2, 51, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 2, 18, 2, 32, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 2, 25, 2, 30, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 3, 5, 2, 10, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 3, 12, 15, 51, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 3, 19, 9, 52, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 3, 26, 17, 30, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 4, 3, 21, 22, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 4, 11, 2, 29, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 4, 17, 17, 31, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 4, 25, 9, 30, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 5, 3, 13, 10, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 5, 10, 11, 7, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 5, 17, 2, 29, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 5, 25, 1, 37, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 6, 2, 1, 25, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 6, 8, 18, 23, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 6, 15, 13, 39, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 6, 23, 16, 56, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 7, 1, 10, 32, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 7, 8, 1, 14, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 7, 15, 3, 25, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 7, 23, 7, 1, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 7, 30, 17, 16, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 8, 6, 8, 50, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 8, 13, 19, 39, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 8, 21, 19, 53, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 8, 28, 22, 40, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 9, 4, 18, 28, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 9, 12, 13, 43, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 9, 20, 7, 46, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 9, 27, 4, 1, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 10, 4, 7, 0, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 10, 12, 8, 39, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 10, 19, 18, 58, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 10, 26, 10, 46, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 11, 2, 22, 42, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 11, 11, 3, 19, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 11, 18, 5, 39, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 11, 24, 20, 19, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 12, 2, 16, 53, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 12, 10, 20, 31, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 12, 17, 16, 5, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2070, 12, 24, 9, 30, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 1, 1, 12, 14, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 1, 9, 11, 7, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 1, 16, 2, 34, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 1, 23, 2, 15, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 1, 31, 7, 15, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 2, 7, 22, 29, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 2, 14, 13, 32, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 2, 21, 21, 28, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 3, 2, 0, 30, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 3, 9, 6, 52, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 3, 16, 1, 17, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 3, 23, 17, 31, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 3, 31, 15, 2, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 4, 7, 13, 16, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 4, 14, 13, 55, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 4, 22, 12, 51, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 4, 30, 2, 29, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 5, 6, 19, 4, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 5, 14, 3, 23, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 5, 22, 6, 17, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 5, 29, 11, 16, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 6, 5, 1, 37, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 6, 12, 17, 35, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 6, 20, 21, 3, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 6, 27, 18, 20, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 7, 4, 10, 1, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 7, 12, 8, 24, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 7, 20, 8, 51, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 7, 27, 0, 55, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 8, 2, 21, 4, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 8, 10, 23, 38, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 8, 18, 17, 56, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 8, 25, 8, 15, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 9, 1, 11, 9, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 9, 9, 14, 50, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 9, 17, 1, 6, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 9, 23, 17, 20, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 10, 1, 4, 20, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 10, 9, 5, 22, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 10, 16, 7, 29, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 10, 23, 4, 48, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 10, 31, 0, 6, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 11, 7, 18, 46, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 11, 14, 14, 23, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 11, 21, 18, 59, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 11, 29, 21, 5, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 12, 7, 6, 56, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 12, 13, 22, 56, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 12, 21, 11, 46, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2071, 12, 29, 17, 15, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 1, 5, 18, 12, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 1, 12, 9, 53, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 1, 20, 6, 34, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 1, 28, 10, 35, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 2, 4, 4, 54, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 2, 10, 23, 26, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 2, 19, 2, 2, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 2, 27, 0, 1, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 3, 4, 15, 16, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 3, 11, 15, 17, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 3, 19, 20, 20, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 3, 27, 9, 42, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 4, 3, 1, 24, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 4, 10, 8, 52, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 4, 18, 11, 56, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 4, 25, 16, 34, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 5, 2, 11, 33, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 5, 10, 3, 16, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 5, 18, 0, 17, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 5, 24, 21, 52, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 5, 31, 22, 17, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 6, 8, 21, 19, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 6, 16, 9, 56, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 6, 23, 2, 56, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 6, 30, 10, 20, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 7, 8, 13, 52, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 7, 15, 17, 55, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 7, 22, 9, 1, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 7, 30, 0, 15, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 8, 7, 4, 14, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 8, 14, 1, 20, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 8, 20, 17, 19, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 8, 28, 15, 58, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 9, 5, 16, 18, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 9, 12, 9, 6, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 9, 19, 4, 57, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 9, 27, 8, 42, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 10, 5, 2, 27, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 10, 11, 17, 54, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 10, 18, 20, 36, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 10, 27, 1, 20, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 11, 3, 11, 15, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 11, 10, 4, 20, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 11, 17, 16, 2, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 11, 25, 16, 58, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 12, 2, 19, 21, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 12, 9, 16, 58, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 12, 17, 13, 49, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2072, 12, 25, 7, 14, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 1, 1, 3, 26, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 1, 8, 8, 10, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 1, 16, 11, 32, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 1, 23, 20, 4, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 1, 30, 12, 17, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 2, 7, 1, 39, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 2, 15, 6, 56, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 2, 22, 7, 25, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 2, 28, 22, 39, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 3, 8, 20, 14, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 3, 16, 22, 43, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 3, 23, 17, 16, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 3, 30, 11, 3, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 4, 7, 14, 13, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 4, 15, 10, 35, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 4, 22, 1, 53, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 4, 29, 1, 37, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 5, 7, 6, 14, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 5, 14, 18, 58, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 5, 21, 10, 1, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 5, 28, 17, 56, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 6, 5, 19, 50, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 6, 13, 0, 46, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 6, 19, 18, 43, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 6, 27, 11, 11, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 7, 5, 7, 15, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 7, 12, 5, 15, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 7, 19, 5, 3, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 7, 27, 4, 28, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 8, 3, 17, 3, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 8, 10, 9, 53, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 8, 17, 17, 44, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 8, 25, 21, 4, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 9, 2, 1, 51, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 9, 8, 16, 18, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 9, 16, 8, 51, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 9, 24, 12, 31, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 10, 1, 10, 20, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 10, 8, 1, 55, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 10, 16, 1, 53, 45),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 10, 24, 2, 21, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 10, 30, 19, 12, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 11, 6, 15, 41, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 11, 14, 19, 54, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 11, 22, 14, 14, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 11, 29, 5, 11, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 12, 6, 9, 32, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 12, 14, 13, 48, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 12, 22, 0, 5, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2073, 12, 28, 16, 54, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 1, 5, 6, 17, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 1, 13, 6, 30, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 1, 20, 8, 19, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 1, 27, 6, 36, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 2, 4, 4, 1, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 2, 11, 21, 4, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 2, 18, 15, 54, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 2, 25, 21, 59, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 3, 6, 0, 42, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 3, 13, 9, 0, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 3, 19, 23, 57, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 3, 27, 14, 18, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 4, 4, 18, 39, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 4, 11, 18, 29, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 4, 18, 9, 21, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 4, 26, 6, 46, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 5, 4, 8, 52, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 5, 11, 2, 17, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 5, 17, 20, 38, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 5, 25, 22, 43, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 6, 2, 19, 13, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 6, 9, 9, 27, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 6, 16, 9, 56, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 6, 24, 13, 37, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 7, 2, 2, 21, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 7, 8, 17, 4, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 7, 16, 1, 10, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 7, 24, 3, 6, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 7, 31, 7, 30, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 8, 7, 2, 5, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 8, 14, 18, 9, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 8, 22, 14, 58, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 8, 29, 12, 11, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 9, 5, 13, 12, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 9, 13, 12, 20, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 9, 21, 1, 28, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 9, 27, 17, 58, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 10, 5, 2, 54, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 10, 13, 6, 46, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 10, 20, 11, 10, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 10, 27, 2, 14, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 11, 3, 19, 21, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 11, 12, 0, 6, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 11, 18, 20, 55, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 11, 25, 13, 51, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 12, 3, 14, 2, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 12, 11, 15, 7, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 12, 18, 7, 19, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2074, 12, 25, 5, 6, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 1, 2, 9, 38, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 1, 10, 3, 13, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 1, 16, 18, 36, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 1, 23, 23, 31, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 2, 1, 4, 12, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 2, 8, 12, 40, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 2, 15, 6, 40, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 2, 22, 19, 59, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 3, 2, 20, 5, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 3, 9, 20, 16, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 3, 16, 19, 24, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 3, 24, 16, 45, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 4, 1, 8, 44, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 4, 8, 3, 2, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 4, 15, 8, 54, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 4, 23, 11, 52, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 4, 30, 18, 36, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 5, 7, 9, 58, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 5, 14, 23, 21, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 5, 23, 3, 56, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 5, 30, 2, 37, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 6, 5, 18, 0, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 6, 13, 14, 38, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 6, 21, 16, 28, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 6, 28, 9, 45, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 7, 5, 3, 59, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 7, 13, 6, 10, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 7, 21, 1, 54, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 7, 27, 16, 53, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 8, 3, 16, 42, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 8, 11, 21, 10, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 8, 19, 9, 11, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 8, 26, 0, 50, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 9, 2, 8, 33, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 9, 10, 11, 1, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 9, 17, 15, 24, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 9, 24, 10, 30, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 10, 2, 3, 12, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 10, 9, 23, 42, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 10, 16, 21, 40, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 10, 23, 22, 48, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 10, 31, 23, 25, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 11, 8, 11, 34, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 11, 15, 5, 5, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 11, 22, 14, 19, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 11, 30, 19, 21, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 12, 7, 23, 2, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 12, 14, 14, 36, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 12, 22, 8, 47, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2075, 12, 30, 13, 19, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 1, 6, 10, 13, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 1, 13, 3, 1, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 1, 21, 4, 39, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 1, 29, 4, 17, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 2, 4, 21, 0, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 2, 11, 18, 34, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 2, 19, 23, 48, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 2, 27, 15, 53, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 3, 5, 7, 23, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 3, 12, 12, 40, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 3, 20, 16, 36, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 3, 28, 0, 25, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 4, 3, 17, 46, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 4, 11, 7, 59, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 4, 19, 6, 28, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 4, 26, 6, 40, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 5, 3, 4, 51, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 5, 11, 2, 49, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 5, 18, 17, 37, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 5, 25, 11, 50, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 6, 1, 17, 13, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 6, 9, 19, 57, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 6, 17, 2, 37, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 6, 23, 17, 20, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 7, 1, 7, 3, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 7, 9, 10, 48, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 7, 16, 10, 11, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 7, 23, 0, 39, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 7, 30, 22, 4, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 8, 7, 23, 20, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 8, 14, 17, 11, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 8, 21, 10, 59, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 8, 29, 13, 42, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 9, 6, 9, 45, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 9, 13, 0, 37, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 9, 20, 1, 5, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 9, 28, 5, 26, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 10, 5, 18, 25, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 10, 12, 9, 36, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 10, 19, 18, 50, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 10, 27, 20, 49, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 11, 4, 1, 56, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 11, 10, 21, 6, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 11, 18, 15, 14, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 11, 26, 11, 27, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 12, 3, 9, 14, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 12, 10, 11, 34, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 12, 18, 12, 38, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2076, 12, 26, 0, 52, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 1, 1, 17, 26, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 1, 9, 4, 37, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 1, 17, 9, 8, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 1, 24, 12, 44, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 1, 31, 3, 34, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 2, 7, 23, 7, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 2, 16, 2, 57, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 2, 22, 23, 6, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 3, 1, 16, 10, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 3, 9, 17, 42, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 3, 17, 16, 55, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 3, 24, 8, 23, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 3, 31, 7, 1, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 4, 8, 11, 5, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 4, 16, 2, 49, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 4, 22, 17, 19, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 4, 29, 23, 27, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 5, 8, 2, 22, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 5, 15, 9, 25, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 5, 22, 2, 37, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 5, 29, 16, 42, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 6, 6, 15, 6, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 6, 13, 14, 7, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 6, 20, 12, 54, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 6, 28, 10, 4, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 7, 6, 1, 21, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 7, 12, 18, 32, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 7, 20, 0, 40, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 7, 28, 2, 54, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 8, 4, 9, 45, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 8, 11, 0, 15, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 8, 18, 14, 16, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 8, 26, 18, 30, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 9, 2, 17, 22, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 9, 9, 8, 34, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 9, 17, 5, 52, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 9, 25, 8, 14, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 10, 2, 1, 19, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 10, 8, 20, 25, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 10, 16, 23, 6, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 10, 24, 19, 50, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 10, 31, 10, 35, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 11, 7, 12, 8, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 11, 15, 16, 59, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 11, 23, 5, 30, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 11, 29, 21, 42, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 12, 7, 7, 25, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 12, 15, 10, 5, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 12, 22, 13, 55, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2077, 12, 29, 10, 44, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 1, 6, 5, 4, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 1, 14, 1, 13, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 1, 20, 21, 58, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 1, 28, 1, 32, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 2, 5, 2, 59, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 2, 12, 13, 58, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 2, 19, 6, 30, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 2, 26, 17, 49, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 3, 6, 22, 46, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 3, 14, 0, 36, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 3, 20, 16, 9, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 3, 28, 11, 3, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 4, 5, 14, 44, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 4, 12, 9, 44, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 4, 19, 3, 18, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 4, 27, 4, 18, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 5, 5, 2, 28, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 5, 11, 17, 55, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 5, 18, 16, 15, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 5, 26, 20, 22, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 6, 3, 10, 37, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 6, 10, 1, 48, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 6, 17, 7, 7, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 6, 25, 10, 21, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 7, 2, 16, 24, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 7, 9, 10, 8, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 7, 16, 23, 47, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 7, 24, 22, 6, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 7, 31, 21, 10, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 8, 7, 19, 51, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 8, 15, 17, 33, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 8, 23, 8, 10, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 8, 30, 2, 15, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 9, 6, 7, 58, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 9, 14, 11, 21, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 9, 21, 17, 30, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 9, 28, 8, 59, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 10, 5, 23, 5, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 10, 14, 4, 6, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 10, 21, 2, 54, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 10, 27, 18, 33, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 11, 4, 16, 55, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 11, 12, 19, 3, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 11, 19, 12, 51, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 11, 26, 7, 53, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 12, 4, 12, 7, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 12, 12, 7, 51, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 12, 18, 23, 33, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2078, 12, 26, 1, 15, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 1, 3, 6, 49, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 1, 10, 18, 28, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 1, 17, 11, 5, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 1, 24, 21, 45, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 2, 1, 23, 34, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 2, 9, 3, 10, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 2, 15, 23, 44, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 2, 23, 19, 22, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 3, 3, 13, 48, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 3, 10, 10, 36, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 3, 17, 13, 45, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 3, 25, 15, 45, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 4, 2, 1, 29, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 4, 8, 17, 43, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 4, 16, 5, 2, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 4, 24, 9, 14, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 5, 1, 10, 56, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 5, 8, 1, 36, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 5, 15, 20, 57, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 5, 23, 23, 14, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 5, 30, 18, 40, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 6, 6, 11, 17, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 6, 14, 12, 38, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 6, 22, 9, 55, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 6, 29, 1, 30, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 7, 5, 23, 30, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 7, 14, 3, 23, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 7, 21, 17, 53, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 7, 28, 8, 32, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 8, 4, 14, 27, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 8, 12, 16, 59, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 8, 19, 23, 59, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 8, 26, 17, 1, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 9, 3, 7, 45, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 9, 11, 5, 35, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 9, 18, 5, 21, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 9, 25, 4, 5, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 10, 3, 2, 34, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 10, 10, 17, 22, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 10, 17, 11, 20, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 10, 24, 18, 18, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 11, 1, 21, 49, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 11, 9, 4, 33, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 11, 15, 19, 25, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 11, 23, 11, 28, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 12, 1, 16, 12, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 12, 8, 15, 15, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 12, 15, 6, 42, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 12, 23, 6, 30, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2079, 12, 31, 8, 28, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 1, 7, 1, 44, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 1, 13, 21, 39, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 1, 22, 1, 54, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 1, 29, 21, 36, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 2, 5, 12, 20, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 2, 12, 15, 36, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 2, 20, 20, 10, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 2, 28, 7, 23, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 3, 5, 23, 28, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 3, 13, 11, 11, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 3, 21, 12, 5, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 3, 28, 14, 31, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 4, 4, 11, 23, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 4, 12, 6, 48, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 4, 20, 0, 59, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 4, 26, 20, 15, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 5, 4, 0, 9, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 5, 12, 1, 10, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 5, 19, 10, 55, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 5, 26, 2, 2, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 6, 2, 13, 45, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 6, 10, 17, 19, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 6, 17, 18, 39, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 6, 24, 9, 11, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 7, 2, 4, 8, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 7, 10, 6, 44, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 7, 17, 1, 20, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 7, 23, 18, 39, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 7, 31, 19, 12, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 8, 8, 17, 20, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 8, 15, 8, 12, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 8, 22, 7, 6, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 8, 30, 10, 40, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 9, 7, 1, 36, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 9, 13, 16, 24, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 9, 20, 22, 47, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 9, 29, 1, 53, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 10, 6, 8, 29, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 10, 13, 2, 43, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 10, 20, 17, 30, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 10, 28, 16, 12, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 11, 4, 15, 9, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 11, 11, 15, 36, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 11, 19, 14, 18, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 11, 27, 5, 13, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 12, 3, 22, 51, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 12, 11, 7, 9, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 12, 19, 11, 22, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2080, 12, 26, 17, 2, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 1, 2, 8, 31, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 1, 10, 1, 1, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 1, 18, 6, 28, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 1, 25, 4, 0, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 1, 31, 20, 36, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 2, 8, 20, 16, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 2, 16, 21, 58, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 2, 23, 14, 26, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 3, 2, 11, 5, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 3, 10, 15, 16, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 3, 18, 9, 26, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 3, 25, 0, 28, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 4, 1, 3, 34, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 4, 9, 8, 14, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 4, 16, 17, 30, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 4, 23, 10, 19, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 4, 30, 21, 23, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 5, 8, 22, 8, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 5, 15, 23, 20, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 5, 22, 20, 25, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 5, 30, 15, 34, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 6, 7, 9, 0, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 6, 14, 4, 15, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 6, 21, 7, 31, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 6, 29, 8, 59, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 7, 6, 17, 43, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 7, 13, 9, 33, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 7, 20, 20, 21, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 7, 29, 0, 39, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 8, 5, 1, 23, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 8, 11, 16, 32, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 8, 19, 11, 14, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 8, 27, 14, 7, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 9, 3, 9, 0, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 9, 10, 2, 21, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 9, 18, 3, 44, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 9, 26, 1, 29, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 10, 2, 17, 22, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 10, 9, 15, 57, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 10, 17, 20, 49, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 10, 25, 11, 12, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 11, 1, 3, 3, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 11, 8, 9, 40, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 11, 16, 13, 18, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 11, 23, 19, 48, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 11, 30, 14, 35, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 12, 8, 6, 37, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 12, 16, 4, 30, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 12, 23, 3, 54, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2081, 12, 30, 4, 27, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 1, 7, 4, 44, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 1, 14, 18, 10, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 1, 21, 12, 14, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 1, 28, 20, 45, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 2, 6, 1, 33, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 2, 13, 6, 15, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 2, 19, 21, 34, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 2, 27, 14, 47, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 3, 7, 19, 14, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 3, 14, 16, 44, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 3, 21, 8, 36, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 3, 29, 9, 4, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 4, 6, 9, 1, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 4, 13, 1, 44, 45),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 4, 19, 21, 45, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 4, 28, 2, 1, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 5, 5, 19, 3, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 5, 12, 9, 48, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 5, 19, 12, 57, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 5, 27, 16, 46, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 6, 4, 2, 0, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 6, 10, 17, 54, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 6, 18, 5, 38, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 6, 26, 5, 15, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 7, 3, 6, 58, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 7, 10, 3, 9, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 7, 17, 22, 58, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 7, 25, 15, 53, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 8, 1, 11, 21, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 8, 8, 14, 32, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 8, 16, 16, 6, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 8, 24, 1, 17, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 8, 30, 16, 41, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 9, 7, 4, 29, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 9, 15, 8, 28, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 9, 22, 10, 3, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 9, 29, 0, 34, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 10, 6, 20, 47, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 10, 14, 23, 31, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 10, 21, 18, 49, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 10, 28, 12, 13, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 11, 5, 14, 37, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 11, 13, 12, 45, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 11, 20, 4, 18, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 11, 27, 4, 6, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 12, 5, 8, 56, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 12, 12, 23, 51, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 12, 19, 15, 10, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2082, 12, 26, 23, 36, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 1, 4, 2, 31, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 1, 11, 8, 54, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 1, 18, 3, 49, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 1, 25, 21, 2, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 2, 2, 18, 19, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 2, 9, 16, 38, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 2, 16, 18, 14, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 2, 24, 18, 23, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 3, 4, 7, 33, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 3, 11, 0, 9, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 3, 18, 9, 55, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 3, 26, 13, 46, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 4, 2, 18, 6, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 4, 9, 8, 30, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 4, 17, 2, 8, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 4, 25, 5, 53, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 5, 2, 2, 29, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 5, 8, 18, 29, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 5, 16, 18, 13, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 5, 24, 18, 10, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 5, 31, 9, 41, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 6, 7, 6, 28, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 6, 15, 9, 36, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 6, 23, 2, 51, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 6, 29, 16, 50, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 7, 6, 20, 32, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 7, 14, 23, 53, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 7, 22, 8, 55, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 7, 29, 1, 0, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 8, 5, 12, 37, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 8, 13, 12, 44, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 8, 20, 13, 45, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 8, 27, 10, 59, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 9, 4, 6, 23, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 9, 12, 0, 6, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 9, 18, 18, 55, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 9, 25, 23, 24, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 10, 4, 1, 6, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 10, 11, 10, 22, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 10, 18, 1, 53, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 10, 25, 14, 35, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 11, 2, 19, 29, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 11, 9, 20, 14, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 11, 16, 11, 47, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 11, 24, 8, 22, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 12, 2, 12, 5, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 12, 9, 6, 24, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 12, 16, 1, 12, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2083, 12, 24, 3, 50, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 1, 1, 1, 53, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 1, 7, 17, 16, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 1, 14, 18, 1, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 1, 22, 23, 14, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 1, 30, 12, 41, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 2, 6, 4, 52, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 2, 13, 13, 27, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 2, 21, 16, 35, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 2, 28, 21, 3, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 3, 6, 17, 3, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 3, 14, 10, 5, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 3, 22, 6, 47, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 3, 29, 3, 57, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 4, 5, 5, 51, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 4, 13, 6, 4, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 4, 20, 17, 51, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 4, 27, 10, 28, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 5, 4, 19, 31, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 5, 12, 23, 42, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 5, 20, 2, 35, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 5, 26, 17, 35, 5),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 6, 3, 10, 12, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 6, 11, 14, 2, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 6, 18, 10, 0, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 6, 25, 2, 15, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 7, 3, 1, 37, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 7, 11, 1, 5, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 7, 17, 17, 0, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 7, 24, 13, 21, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 8, 1, 17, 3, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 8, 9, 9, 31, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 8, 16, 0, 28, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 8, 23, 3, 33, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 8, 31, 7, 44, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 9, 7, 16, 22, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 9, 14, 9, 14, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 9, 21, 20, 58, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 9, 29, 21, 15, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 10, 6, 22, 41, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 10, 13, 20, 12, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 10, 21, 16, 48, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 10, 29, 9, 46, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 11, 5, 5, 32, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 11, 12, 10, 9, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 11, 20, 13, 22, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 11, 27, 21, 38, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 12, 4, 13, 56, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 12, 12, 3, 18, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 12, 20, 8, 43, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2084, 12, 27, 9, 6, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 1, 3, 0, 46, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 1, 10, 22, 41, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 1, 19, 1, 25, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 1, 25, 20, 6, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 2, 1, 14, 35, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 2, 9, 18, 23, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 2, 17, 14, 46, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 2, 24, 6, 31, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 3, 3, 7, 15, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 3, 11, 12, 24, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 3, 19, 0, 44, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 3, 25, 16, 36, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 4, 2, 1, 50, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 4, 10, 3, 40, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 4, 17, 7, 53, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 4, 24, 2, 58, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 5, 1, 20, 51, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 5, 9, 16, 3, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 5, 16, 13, 18, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 5, 23, 14, 22, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 5, 31, 14, 50, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 6, 8, 2, 1, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 6, 14, 18, 18, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 6, 22, 3, 17, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 6, 30, 6, 54, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 7, 7, 10, 14, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 7, 14, 0, 23, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 7, 21, 17, 42, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 7, 29, 20, 46, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 8, 5, 17, 28, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 8, 12, 8, 59, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 8, 20, 9, 9, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 8, 28, 8, 29, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 9, 4, 0, 40, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 9, 10, 21, 6, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 9, 19, 1, 6, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 9, 26, 18, 17, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 10, 3, 8, 52, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 10, 10, 13, 8, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 10, 18, 16, 59, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 10, 26, 2, 34, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 11, 1, 19, 8, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 11, 9, 8, 30, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 11, 17, 8, 20, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 11, 24, 10, 1, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 12, 1, 8, 9, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 12, 9, 5, 46, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 12, 16, 22, 37, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 12, 23, 17, 41, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2085, 12, 30, 23, 58, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 1, 8, 3, 4, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 1, 15, 11, 23, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 1, 22, 2, 40, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 1, 29, 17, 47, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 2, 6, 22, 29, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 2, 13, 22, 26, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 2, 20, 13, 47, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 2, 28, 12, 20, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 3, 8, 14, 29, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 3, 15, 8, 3, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 3, 22, 3, 15, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 3, 30, 6, 16, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 4, 7, 2, 21, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 4, 13, 16, 52, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 4, 20, 18, 39, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 4, 28, 22, 34, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 5, 6, 10, 25, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 5, 13, 1, 40, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 5, 20, 11, 18, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 5, 28, 12, 34, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 6, 4, 15, 50, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 6, 11, 11, 11, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 6, 19, 4, 32, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 6, 27, 0, 3, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 7, 3, 20, 9, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 7, 10, 22, 1, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 7, 18, 21, 44, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 7, 26, 9, 23, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 8, 2, 1, 0, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 8, 9, 10, 37, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 8, 17, 14, 13, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 8, 24, 17, 24, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 8, 31, 7, 51, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 9, 8, 1, 16, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 9, 16, 5, 16, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 9, 23, 1, 14, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 9, 29, 17, 51, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 10, 7, 17, 55, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 10, 15, 18, 17, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 10, 22, 9, 55, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 10, 29, 7, 39, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 11, 6, 11, 52, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 11, 14, 5, 10, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 11, 20, 20, 11, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 11, 28, 1, 16, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 12, 6, 5, 47, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 12, 13, 14, 19, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 12, 20, 8, 18, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2086, 12, 27, 21, 57, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 1, 4, 22, 10, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 1, 11, 22, 29, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 1, 18, 22, 10, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 1, 26, 20, 0, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 2, 3, 12, 9, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 2, 10, 6, 37, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 2, 17, 13, 33, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 2, 25, 17, 5, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 3, 4, 23, 44, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 3, 11, 15, 25, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 3, 19, 6, 8, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 3, 27, 11, 3, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 4, 3, 9, 25, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 4, 10, 1, 28, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 4, 17, 23, 16, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 4, 26, 0, 50, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 5, 2, 17, 50, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 5, 9, 13, 8, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 5, 17, 15, 54, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 5, 25, 10, 40, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 6, 1, 1, 37, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 6, 8, 2, 44, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 6, 16, 6, 57, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 6, 23, 17, 32, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 6, 30, 9, 30, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 7, 7, 18, 22, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 7, 15, 19, 53, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 7, 22, 22, 42, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 7, 29, 18, 19, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 8, 6, 11, 42, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 8, 14, 6, 53, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 8, 21, 3, 33, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 8, 28, 5, 7, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 9, 5, 5, 48, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 9, 12, 16, 42, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 9, 19, 9, 22, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 9, 26, 18, 46, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 10, 4, 23, 31, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 10, 12, 2, 13, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 10, 18, 17, 26, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 10, 26, 11, 28, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 11, 3, 15, 47, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 11, 10, 12, 4, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 11, 17, 4, 50, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 11, 25, 6, 22, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 12, 3, 6, 0, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 12, 9, 22, 30, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 12, 16, 20, 10, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2087, 12, 25, 1, 41, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 1, 1, 17, 53, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 1, 8, 9, 36, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 1, 15, 15, 12, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 1, 23, 19, 37, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 1, 31, 3, 32, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 2, 6, 21, 31, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 2, 14, 12, 23, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 2, 22, 11, 8, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 2, 29, 11, 25, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 3, 7, 10, 35, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 3, 15, 9, 28, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 3, 22, 23, 59, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 3, 29, 18, 22, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 4, 6, 0, 58, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 4, 14, 4, 25, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 4, 21, 10, 24, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 4, 28, 1, 27, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 5, 5, 16, 24, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 5, 13, 20, 8, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 5, 20, 18, 48, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 5, 27, 9, 50, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 6, 4, 8, 7, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 6, 12, 8, 29, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 6, 19, 1, 53, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 6, 25, 20, 28, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 7, 3, 23, 21, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 7, 11, 17, 51, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 7, 18, 8, 37, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 7, 25, 9, 53, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 8, 2, 13, 38, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 8, 10, 0, 56, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 8, 16, 16, 14, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 8, 24, 2, 4, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 9, 1, 2, 56, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 9, 8, 6, 42, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 9, 15, 1, 57, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 9, 22, 20, 24, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 9, 30, 15, 24, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 10, 7, 12, 23, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 10, 14, 14, 38, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 10, 22, 15, 50, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 10, 30, 3, 9, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 11, 5, 19, 21, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 11, 13, 6, 30, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 11, 21, 11, 7, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 11, 28, 14, 17, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 12, 5, 4, 57, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 12, 13, 0, 51, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 12, 21, 4, 51, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2088, 12, 28, 0, 56, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 1, 3, 17, 59, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 1, 11, 20, 16, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 1, 19, 19, 46, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 1, 26, 11, 24, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 2, 2, 10, 22, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 2, 10, 15, 15, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 2, 18, 7, 14, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 2, 24, 22, 4, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 3, 4, 5, 4, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 3, 12, 8, 23, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 3, 19, 15, 29, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 3, 26, 9, 19, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 4, 3, 0, 34, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 4, 10, 22, 44, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 4, 17, 21, 36, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 4, 24, 21, 21, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 5, 2, 19, 30, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 5, 10, 10, 2, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 5, 17, 3, 0, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 5, 24, 10, 17, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 6, 1, 12, 48, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 6, 8, 18, 43, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 6, 15, 9, 8, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 6, 23, 0, 6, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 7, 1, 3, 43, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 7, 8, 1, 46, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 7, 14, 17, 10, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 7, 22, 14, 49, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 7, 30, 15, 54, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 8, 6, 8, 27, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 8, 13, 3, 57, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 8, 21, 6, 14, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 8, 29, 1, 31, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 9, 4, 15, 57, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 9, 11, 18, 0, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 9, 19, 21, 54, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 9, 27, 9, 14, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 10, 4, 1, 14, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 10, 11, 11, 21, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 10, 19, 13, 3, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 10, 26, 16, 5, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 11, 2, 12, 54, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 11, 10, 7, 27, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 11, 18, 3, 1, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 11, 24, 23, 17, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 12, 2, 3, 10, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 12, 10, 4, 51, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 12, 17, 15, 36, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 12, 24, 7, 54, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2089, 12, 31, 19, 56, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 1, 9, 1, 20, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 1, 16, 3, 2, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 1, 22, 18, 37, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 1, 30, 14, 33, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 2, 7, 18, 51, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 2, 14, 13, 38, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 2, 21, 7, 41, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 3, 1, 9, 45, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 3, 9, 8, 19, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 3, 15, 23, 41, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 3, 22, 22, 54, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 3, 31, 3, 47, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 4, 7, 17, 55, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 4, 14, 9, 21, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 4, 21, 15, 48, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 4, 29, 19, 11, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 5, 7, 0, 37, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 5, 13, 19, 0, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 5, 21, 9, 42, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 5, 29, 7, 28, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 6, 5, 5, 44, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 6, 12, 5, 17, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 6, 20, 3, 32, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 6, 27, 17, 10, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 7, 4, 10, 36, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 7, 11, 17, 1, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 7, 19, 20, 15, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 7, 27, 1, 18, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 8, 2, 16, 30, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 8, 10, 6, 50, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 8, 18, 11, 4, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 8, 25, 8, 58, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 9, 1, 0, 43, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 9, 8, 22, 43, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 9, 16, 23, 47, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 9, 23, 17, 2, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 9, 30, 12, 20, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 10, 8, 15, 53, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 10, 16, 10, 35, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 10, 23, 2, 8, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 10, 30, 4, 3, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 11, 7, 9, 4, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 11, 14, 19, 57, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 11, 21, 12, 47, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 11, 28, 23, 39, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 12, 7, 1, 13, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 12, 14, 4, 24, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 12, 21, 1, 28, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2090, 12, 28, 21, 35, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 1, 5, 15, 49, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 1, 12, 12, 33, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 1, 19, 16, 30, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 1, 27, 19, 23, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 2, 4, 4, 45, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 2, 10, 21, 10, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 2, 18, 9, 37, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 2, 26, 14, 46, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 3, 5, 15, 58, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 3, 12, 7, 1, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 3, 20, 3, 45, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 3, 28, 6, 30, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 4, 4, 1, 30, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 4, 10, 18, 44, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 4, 18, 21, 19, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 4, 26, 18, 19, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 5, 3, 9, 45, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 5, 10, 8, 35, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 5, 18, 13, 6, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 5, 26, 2, 41, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 6, 1, 17, 30, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 6, 9, 0, 21, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 6, 17, 2, 40, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 6, 24, 8, 30, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 7, 1, 1, 53, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 7, 8, 17, 20, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 7, 16, 14, 14, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 7, 23, 13, 1, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 7, 30, 12, 0, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 8, 7, 10, 44, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 8, 15, 0, 21, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 8, 21, 17, 42, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 8, 29, 0, 38, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 9, 6, 3, 46, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 9, 13, 9, 33, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 9, 20, 0, 9, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 9, 27, 15, 55, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 10, 5, 19, 52, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 10, 12, 18, 28, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 10, 19, 9, 49, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 10, 27, 9, 17, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 11, 4, 10, 25, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 11, 11, 3, 41, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 11, 17, 23, 37, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 11, 26, 3, 42, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 12, 3, 22, 54, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 12, 10, 13, 53, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 12, 17, 17, 28, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2091, 12, 25, 21, 58, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 1, 2, 9, 6, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 1, 9, 1, 36, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 1, 16, 14, 7, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 1, 24, 14, 54, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 1, 31, 17, 24, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 2, 7, 15, 2, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 2, 15, 11, 39, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 2, 23, 5, 28, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 3, 1, 0, 45, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 3, 8, 5, 55, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 3, 16, 8, 6, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 3, 23, 17, 15, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 3, 30, 8, 20, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 4, 6, 21, 40, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 4, 15, 1, 53, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 4, 22, 2, 28, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 4, 28, 17, 7, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 5, 6, 13, 38, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 5, 14, 16, 5, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 5, 21, 9, 59, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 5, 28, 3, 45, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 6, 5, 5, 16, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 6, 13, 2, 32, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 6, 19, 16, 55, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 6, 26, 16, 31, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 7, 4, 20, 9, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 7, 12, 9, 53, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 7, 19, 0, 23, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 7, 26, 7, 30, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 8, 3, 9, 53, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 8, 10, 15, 17, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 8, 17, 9, 21, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 8, 25, 0, 31, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 9, 1, 22, 13, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 9, 8, 20, 14, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 9, 15, 20, 32, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 9, 23, 19, 4, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 10, 1, 9, 14, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 10, 8, 2, 15, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 10, 15, 10, 25, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 10, 23, 14, 6, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 10, 30, 19, 28, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 11, 6, 10, 39, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 11, 14, 3, 3, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 11, 22, 8, 6, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 11, 29, 5, 35, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 12, 5, 22, 17, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 12, 13, 21, 58, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 12, 21, 23, 38, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2092, 12, 28, 16, 9, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 1, 4, 13, 21, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 1, 12, 17, 42, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 1, 20, 12, 2, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 1, 27, 3, 21, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 2, 3, 7, 26, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 2, 11, 12, 17, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 2, 18, 21, 31, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 2, 25, 15, 4, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 3, 5, 3, 26, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 3, 13, 4, 5, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 3, 20, 4, 56, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 3, 27, 3, 17, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 4, 3, 23, 45, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 4, 11, 16, 35, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 4, 18, 11, 19, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 4, 25, 16, 11, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 5, 3, 18, 36, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 5, 11, 2, 16, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 5, 17, 17, 46, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 5, 25, 6, 6, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 6, 2, 10, 38, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 6, 9, 10, 8, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 6, 16, 1, 18, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 6, 23, 21, 3, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 7, 1, 23, 23, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 7, 8, 17, 13, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 7, 15, 10, 53, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 7, 23, 12, 35, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 7, 31, 9, 12, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 8, 7, 0, 22, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 8, 13, 23, 22, 48),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 8, 22, 3, 52, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 8, 29, 16, 57, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 9, 5, 8, 27, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 9, 12, 15, 14, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 9, 20, 18, 15, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 9, 27, 23, 38, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 10, 4, 18, 17, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 10, 12, 10, 9, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 10, 20, 7, 32, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 10, 27, 6, 17, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 11, 3, 6, 45, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 11, 11, 6, 49, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 11, 18, 19, 57, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 11, 25, 13, 53, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 12, 2, 22, 23, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 12, 11, 3, 14, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 12, 18, 7, 46, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2093, 12, 24, 23, 24, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 1, 1, 16, 50, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 1, 9, 21, 35, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 1, 16, 19, 4, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 1, 23, 11, 33, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 1, 31, 12, 35, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 2, 8, 12, 44, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 2, 15, 5, 42, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 2, 22, 2, 35, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 3, 2, 7, 34, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 3, 10, 0, 21, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 3, 16, 15, 43, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 3, 23, 20, 4, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 4, 1, 0, 10, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 4, 8, 8, 45, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 4, 15, 1, 36, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 4, 22, 14, 47, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 4, 30, 13, 53, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 5, 7, 14, 47, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 5, 14, 12, 8, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 5, 22, 9, 15, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 5, 30, 0, 57, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 6, 5, 19, 40, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 6, 13, 0, 2, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 6, 21, 2, 18, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 6, 28, 9, 58, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 7, 5, 0, 53, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 7, 12, 13, 36, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 7, 20, 17, 24, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 7, 27, 17, 39, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 8, 3, 7, 57, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 8, 11, 4, 36, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 8, 19, 6, 25, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 8, 26, 0, 51, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 9, 1, 18, 8, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 9, 9, 20, 30, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 9, 17, 17, 27, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 9, 24, 8, 32, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 10, 1, 8, 14, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 10, 9, 12, 43, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 10, 17, 2, 44, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 10, 23, 17, 47, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 10, 31, 2, 8, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 11, 8, 4, 41, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 11, 15, 10, 44, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 11, 22, 5, 26, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 11, 29, 22, 47, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 12, 7, 19, 49, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 12, 14, 18, 16, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 12, 21, 19, 55, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2094, 12, 29, 20, 26, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 1, 6, 9, 32, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 1, 13, 2, 27, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 1, 20, 12, 47, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 1, 28, 17, 6, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 2, 4, 21, 27, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 2, 11, 12, 16, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 2, 19, 6, 58, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 2, 27, 10, 57, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 3, 6, 7, 38, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 3, 13, 0, 17, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 3, 21, 1, 9, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 3, 29, 0, 53, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 4, 4, 16, 35, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 4, 11, 14, 26, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 4, 19, 18, 13, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 4, 27, 10, 44, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 5, 4, 1, 5, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 5, 11, 6, 13, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 5, 19, 9, 20, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 5, 26, 17, 16, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 6, 2, 9, 57, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 6, 9, 23, 1, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 6, 17, 22, 4, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 6, 24, 21, 54, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 7, 1, 19, 53, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 7, 9, 16, 14, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 7, 17, 8, 30, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 7, 24, 2, 16, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 7, 31, 7, 28, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 8, 8, 9, 18, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 8, 15, 17, 12, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 8, 22, 7, 55, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 8, 29, 21, 4, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 9, 7, 1, 25, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 9, 14, 1, 10, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 9, 20, 16, 14, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 9, 28, 12, 53, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 10, 6, 15, 51, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 10, 13, 9, 29, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 10, 20, 4, 7, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 10, 28, 6, 31, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 11, 5, 4, 8, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 11, 11, 19, 4, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 11, 18, 19, 54, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 11, 27, 0, 53, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 12, 4, 14, 20, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 12, 11, 6, 20, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 12, 18, 15, 13, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2095, 12, 26, 18, 23, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 1, 2, 23, 1, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 1, 9, 19, 19, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 1, 17, 12, 50, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 1, 25, 9, 44, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 2, 1, 7, 2, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 2, 8, 9, 49, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 2, 16, 10, 38, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 2, 23, 22, 27, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 3, 1, 15, 15, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 3, 9, 1, 36, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 3, 17, 6, 17, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 3, 24, 8, 54, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 3, 31, 0, 20, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 4, 7, 18, 17, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 4, 15, 22, 9, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 4, 22, 17, 42, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 4, 29, 10, 48, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 5, 7, 11, 5, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 5, 15, 9, 53, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 5, 22, 1, 34, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 5, 28, 23, 6, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 6, 6, 2, 57, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 6, 13, 18, 8, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 6, 20, 9, 11, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 6, 27, 13, 30, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 7, 5, 17, 1, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 7, 13, 0, 4, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 7, 19, 17, 19, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 7, 27, 5, 58, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 8, 4, 5, 4, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 8, 11, 5, 0, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 8, 18, 2, 59, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 8, 25, 23, 55, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 9, 2, 15, 35, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 9, 9, 10, 16, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 9, 16, 15, 9, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 9, 24, 18, 13, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 10, 2, 1, 23, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 10, 8, 17, 8, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 10, 16, 6, 27, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 10, 24, 11, 39, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 10, 31, 11, 15, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 11, 7, 2, 47, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 11, 15, 0, 34, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 11, 23, 3, 17, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 11, 29, 21, 33, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 12, 6, 16, 6, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 12, 14, 20, 4, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 12, 22, 16, 35, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2096, 12, 29, 8, 22, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 1, 5, 9, 19, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 1, 13, 14, 59, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 1, 21, 3, 26, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 1, 27, 19, 46, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 2, 4, 5, 31, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 2, 12, 7, 48, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 2, 19, 12, 6, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 2, 26, 8, 1, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 3, 6, 2, 46, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 3, 13, 21, 56, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 3, 20, 19, 15, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 3, 27, 21, 27, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 4, 4, 22, 49, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 4, 12, 9, 25, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 4, 19, 1, 53, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 4, 26, 12, 8, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 5, 4, 16, 8, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 5, 11, 18, 39, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 5, 18, 9, 13, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 5, 26, 3, 35, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 6, 3, 6, 10, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 6, 10, 2, 12, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 6, 16, 18, 21, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 6, 24, 19, 2, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 7, 2, 17, 4, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 7, 9, 8, 57, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 7, 16, 6, 9, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 7, 24, 9, 53, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 8, 1, 1, 23, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 8, 7, 15, 59, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 8, 14, 20, 55, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 8, 22, 23, 52, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 8, 30, 7, 53, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 9, 6, 0, 32, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 9, 13, 14, 21, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 9, 21, 12, 59, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 9, 28, 13, 38, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 10, 5, 11, 44, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 10, 13, 9, 34, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 10, 21, 1, 22, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 10, 27, 19, 55, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 11, 4, 2, 7, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 11, 12, 5, 22, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 11, 19, 13, 2, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 11, 26, 4, 6, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 12, 3, 19, 25, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 12, 12, 0, 18, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 12, 19, 0, 3, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2097, 12, 25, 15, 19, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 1, 2, 14, 31, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 1, 10, 16, 56, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 1, 17, 10, 35, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 1, 24, 5, 57, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 2, 1, 9, 53, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 2, 9, 6, 15, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 2, 15, 20, 59, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 2, 22, 23, 25, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 3, 3, 4, 1, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 3, 10, 16, 0, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 3, 17, 7, 42, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 3, 24, 18, 25, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 4, 1, 19, 46, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 4, 8, 22, 55, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 4, 15, 19, 3, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 4, 23, 13, 32, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 5, 1, 8, 31, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 5, 8, 4, 20, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 5, 15, 7, 15, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 5, 23, 7, 38, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 5, 30, 18, 22, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 6, 6, 9, 44, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 6, 13, 20, 24, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 6, 21, 23, 49, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 6, 29, 2, 5, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 7, 5, 16, 30, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 7, 13, 10, 34, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 7, 21, 13, 33, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 7, 28, 8, 50, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 8, 4, 1, 42, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 8, 12, 1, 43, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 8, 20, 0, 40, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 8, 26, 15, 52, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 9, 2, 14, 2, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 9, 10, 17, 32, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 9, 18, 9, 31, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 9, 25, 0, 16, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 10, 2, 5, 47, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 10, 10, 9, 19, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 10, 17, 16, 56, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 10, 24, 10, 48, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 11, 1, 0, 46, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 11, 9, 0, 14, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 11, 16, 0, 0, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 11, 22, 23, 50, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 11, 30, 21, 55, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 12, 8, 13, 44, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 12, 15, 7, 51, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 12, 22, 15, 23, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2098, 12, 30, 19, 19, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 1, 7, 1, 49, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 1, 13, 17, 25, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 1, 21, 9, 6, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 1, 29, 14, 37, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 2, 5, 12, 48, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 2, 12, 5, 7, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 2, 20, 4, 5, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 2, 28, 6, 12, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 3, 6, 22, 59, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 3, 13, 18, 59, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 3, 21, 22, 45, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 3, 29, 17, 38, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 4, 5, 8, 36, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 4, 12, 10, 47, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 4, 20, 15, 29, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 4, 28, 1, 35, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 5, 4, 17, 57, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 5, 12, 3, 59, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 5, 20, 5, 15, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 5, 27, 7, 15, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 6, 3, 3, 36, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 6, 10, 21, 48, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 6, 18, 16, 9, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 6, 25, 11, 59, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 7, 2, 14, 20, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 7, 10, 15, 13, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 7, 18, 1, 0, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 7, 24, 17, 8, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 8, 1, 2, 59, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 8, 9, 7, 13, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 8, 16, 8, 53, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 8, 23, 0, 0, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 8, 30, 17, 55, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 9, 7, 21, 17, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 9, 14, 16, 50, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 9, 21, 9, 47, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 9, 29, 10, 44, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 10, 7, 9, 20, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 10, 14, 1, 31, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 10, 20, 23, 26, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 10, 29, 4, 19, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 11, 5, 19, 41, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 11, 12, 11, 28, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 11, 19, 17, 16, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 11, 27, 21, 21, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 12, 5, 4, 44, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 12, 11, 23, 8, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 12, 19, 14, 21, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2099, 12, 27, 12, 57, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 1, 3, 13, 2, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 1, 10, 12, 55, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 1, 18, 12, 33, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 1, 26, 2, 49, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 2, 1, 21, 15, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 2, 9, 4, 54, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 2, 17, 9, 21, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 2, 24, 14, 50, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 3, 3, 6, 10, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 3, 10, 22, 28, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 3, 19, 2, 57, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 3, 26, 1, 4, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 4, 1, 16, 34, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 4, 9, 16, 15, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 4, 17, 16, 41, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 4, 24, 9, 42, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 5, 1, 5, 0, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 5, 9, 8, 53, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 5, 17, 2, 41, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 5, 23, 17, 24, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 5, 30, 19, 34, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 6, 7, 23, 30, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 6, 15, 9, 40, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 6, 22, 1, 10, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 6, 29, 11, 51, 21),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 7, 7, 12, 5, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 7, 14, 14, 42, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 7, 21, 10, 11, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 7, 29, 5, 7, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 8, 5, 23, 1, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 8, 12, 19, 9, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 8, 19, 21, 29, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 8, 27, 22, 35, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 9, 4, 8, 49, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 9, 11, 0, 34, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 9, 18, 11, 31, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 9, 26, 15, 32, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 10, 3, 18, 2, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 10, 10, 8, 32, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 10, 18, 4, 5, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 10, 26, 7, 18, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 11, 2, 3, 13, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 11, 8, 20, 14, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 11, 16, 22, 18, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 11, 24, 21, 12, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 12, 1, 13, 0, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 12, 8, 12, 8, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 12, 16, 16, 59, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 12, 24, 8, 45, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2100, 12, 30, 23, 55, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 1, 7, 7, 32, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 1, 15, 10, 50, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 1, 22, 17, 59, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 1, 29, 12, 24, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 2, 6, 4, 45, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 2, 14, 2, 42, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 2, 21, 1, 35, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 2, 28, 2, 23, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 3, 8, 1, 49, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 3, 15, 15, 49, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 3, 22, 8, 43, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 3, 29, 17, 30, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 4, 6, 20, 58, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 4, 14, 2, 7, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 4, 20, 16, 30, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 4, 28, 9, 8, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 5, 6, 12, 59, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 5, 13, 10, 14, 46),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 5, 20, 1, 51, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 5, 28, 0, 48, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 6, 5, 1, 19, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 6, 11, 17, 13, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 6, 18, 13, 16, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 6, 26, 16, 4, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 7, 4, 10, 13, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 7, 11, 0, 13, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 7, 18, 2, 58, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 7, 26, 6, 30, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 8, 2, 16, 35, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 8, 9, 8, 18, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 8, 16, 18, 57, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 8, 24, 19, 45, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 8, 31, 21, 43, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 9, 7, 18, 20, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 9, 15, 12, 58, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 9, 23, 7, 40, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 9, 30, 3, 10, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 10, 7, 6, 54, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 10, 15, 8, 11, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 10, 22, 18, 29, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 10, 29, 10, 20, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 11, 5, 22, 16, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 11, 14, 3, 13, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 11, 21, 4, 47, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 11, 27, 20, 19, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 12, 5, 16, 16, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 12, 13, 20, 24, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 12, 20, 15, 13, 33),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2101, 12, 27, 9, 38, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 1, 4, 11, 52, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 1, 12, 10, 35, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 1, 19, 2, 6, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 1, 26, 2, 9, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 2, 3, 7, 18, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 2, 10, 21, 31, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 2, 17, 13, 27, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 2, 24, 21, 7, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 3, 5, 0, 36, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 3, 12, 5, 47, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 3, 19, 1, 10, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 3, 26, 17, 15, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 4, 3, 14, 39, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 4, 10, 12, 23, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 4, 17, 13, 24, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 4, 25, 12, 51, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 5, 3, 1, 33, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 5, 9, 18, 28, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 5, 17, 2, 29, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 5, 25, 6, 20, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 6, 1, 10, 8, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 6, 8, 1, 7, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 6, 15, 16, 45, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 6, 23, 20, 47, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 6, 30, 17, 27, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 7, 7, 9, 21, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 7, 15, 8, 0, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 7, 23, 8, 10, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 7, 30, 0, 29, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 8, 5, 20, 9, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 8, 13, 23, 36, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 8, 21, 17, 4, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 8, 28, 8, 4, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 9, 4, 10, 16, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 9, 12, 14, 43, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 9, 20, 0, 25, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 9, 26, 17, 0, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 10, 4, 3, 50, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 10, 12, 4, 50, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 10, 19, 7, 10, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 10, 26, 4, 8, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 11, 3, 0, 1, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 11, 10, 17, 56, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 11, 17, 14, 19, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 11, 24, 18, 13, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 12, 2, 21, 3, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 12, 10, 6, 15, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 12, 16, 22, 49, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2102, 12, 24, 11, 24, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 1, 1, 16, 49, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 1, 8, 17, 56, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 1, 15, 9, 29, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 1, 23, 6, 42, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 1, 31, 9, 47, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 2, 7, 4, 53, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 2, 13, 22, 52, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 2, 22, 2, 13, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 3, 1, 23, 12, 12),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 3, 8, 15, 1, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 3, 15, 14, 56, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 3, 23, 20, 1, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 3, 31, 9, 5, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 4, 7, 0, 39, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 4, 14, 8, 52, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 4, 22, 11, 5, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 4, 29, 16, 4, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 5, 6, 10, 30, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 5, 14, 3, 23, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 5, 21, 23, 21, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 5, 28, 21, 14, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 6, 4, 21, 23, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 6, 12, 21, 8, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 6, 20, 9, 18, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 6, 27, 1, 58, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 7, 4, 9, 56, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 7, 12, 13, 19, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 7, 19, 17, 36, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 7, 26, 7, 49, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 8, 3, 0, 12, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 8, 11, 3, 35, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 8, 18, 1, 2, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 8, 24, 16, 14, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 9, 1, 15, 49, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 9, 9, 15, 54, 10),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 9, 16, 8, 30, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 9, 23, 4, 19, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 10, 1, 8, 10, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 10, 9, 2, 20, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 10, 15, 16, 59, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 10, 22, 20, 26, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 10, 31, 0, 36, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 11, 7, 11, 11, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 11, 14, 3, 28, 1),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 11, 21, 16, 0, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 11, 29, 16, 30, 56),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 12, 6, 19, 0, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 12, 13, 16, 34, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 12, 21, 13, 30, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2103, 12, 29, 7, 12, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 1, 5, 2, 46, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 1, 12, 8, 17, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 1, 20, 10, 58, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 1, 27, 20, 7, 5),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 2, 3, 11, 34, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 2, 11, 1, 49, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 2, 19, 6, 27, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 2, 26, 7, 4, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 3, 3, 22, 12, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 3, 11, 19, 57, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 3, 19, 22, 25, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 3, 26, 16, 23, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 4, 2, 11, 0, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 4, 10, 13, 30, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 4, 18, 10, 13, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 4, 25, 0, 48, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 5, 2, 1, 41, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 5, 10, 5, 32, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 5, 17, 18, 15, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 5, 24, 9, 10, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 5, 31, 17, 45, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 6, 8, 19, 27, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 6, 15, 23, 37, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 6, 22, 18, 19, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 6, 30, 10, 41, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 7, 8, 7, 3, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 7, 15, 3, 53, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 7, 22, 4, 53, 54),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 7, 30, 3, 57, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 8, 6, 16, 39, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 8, 13, 8, 43, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 8, 20, 17, 25, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 8, 28, 20, 51, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 9, 5, 1, 3, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 9, 11, 15, 34, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 9, 19, 8, 12, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 9, 27, 12, 33, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 10, 4, 9, 16, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 10, 11, 1, 36, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 10, 19, 1, 11, 46),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 10, 27, 2, 18, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 11, 2, 18, 18, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 11, 9, 15, 27, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 11, 17, 19, 35, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 11, 25, 13, 48, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 12, 2, 4, 49, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 12, 9, 9, 6, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 12, 17, 13, 56, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 12, 24, 23, 20, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2104, 12, 31, 16, 58, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 1, 8, 5, 45, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 1, 16, 6, 35, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 1, 23, 7, 36, 45),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 1, 30, 6, 36, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 2, 7, 3, 41, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 2, 14, 20, 39, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 2, 21, 15, 31, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 2, 28, 21, 33, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 3, 9, 0, 36, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 3, 16, 8, 5, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 3, 22, 23, 52, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 3, 30, 13, 35, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 4, 7, 18, 25, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 4, 14, 17, 30, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 4, 21, 9, 16, 57),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 4, 29, 6, 12, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 5, 7, 8, 11, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 5, 14, 1, 36, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 5, 20, 20, 17, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 5, 28, 22, 31, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 6, 5, 18, 5, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 6, 12, 9, 7, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 6, 19, 9, 19, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 6, 27, 13, 33, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 7, 5, 1, 6, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 7, 11, 16, 48, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 7, 19, 0, 39, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 7, 27, 2, 42, 17),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 8, 3, 6, 29, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 8, 10, 1, 32, 11),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 8, 17, 17, 59, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 8, 25, 14, 6, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 9, 1, 11, 32, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 9, 8, 12, 21, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 9, 16, 12, 28, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 9, 24, 0, 24, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 9, 30, 17, 32, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 10, 8, 2, 7, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 10, 16, 6, 47, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 10, 23, 10, 25, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 10, 30, 1, 43, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 11, 6, 19, 3, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 11, 14, 23, 44, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 11, 21, 20, 39, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 11, 28, 13, 8, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 12, 6, 14, 14, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 12, 14, 14, 30, 51),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 12, 21, 7, 19, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2105, 12, 28, 4, 22, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 1, 5, 9, 46, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 1, 13, 2, 44, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 1, 19, 18, 22, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 1, 26, 23, 6, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 2, 4, 3, 47, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 2, 11, 12, 28, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 2, 18, 5, 59, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 2, 25, 19, 55, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 3, 5, 19, 15, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 3, 12, 20, 11, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 3, 19, 18, 33, 7),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 3, 27, 16, 37, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 4, 4, 7, 57, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 4, 11, 2, 44, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 4, 18, 8, 20, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 4, 26, 11, 18, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 5, 3, 18, 10, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 5, 10, 9, 19, 47),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 5, 17, 23, 12, 47),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 5, 26, 2, 58, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 6, 2, 2, 23, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 6, 8, 17, 10, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 6, 16, 14, 36, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 6, 24, 15, 29, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 7, 1, 9, 22, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 7, 8, 3, 19, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 7, 16, 5, 47, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 7, 24, 1, 10, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 7, 30, 16, 6, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 8, 6, 16, 28, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 8, 14, 20, 20, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 8, 22, 8, 41, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 8, 28, 23, 46, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 9, 5, 8, 38, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 9, 13, 10, 7, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 9, 20, 14, 52, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 9, 27, 9, 36, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 10, 5, 3, 14, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 10, 12, 23, 9, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 10, 19, 20, 53, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 10, 26, 22, 27, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 11, 3, 23, 9, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 11, 11, 11, 27, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 11, 18, 4, 3, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 11, 25, 14, 27, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 12, 3, 18, 58, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 12, 10, 22, 59, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 12, 17, 13, 40, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2106, 12, 25, 8, 52, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 1, 2, 13, 9, 24),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 1, 9, 9, 48, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 1, 16, 2, 29, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 1, 24, 4, 16, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 2, 1, 4, 20, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 2, 7, 20, 9, 45),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 2, 14, 18, 26, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 2, 22, 23, 7, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 3, 2, 15, 50, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 3, 9, 6, 29, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 3, 16, 12, 33, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 3, 24, 16, 5, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 3, 31, 23, 58, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 4, 7, 17, 14, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 4, 15, 7, 29, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 4, 23, 6, 17, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 4, 30, 5, 49, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 5, 7, 4, 42, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 5, 15, 2, 2, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 5, 22, 17, 28, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 5, 29, 10, 53, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 6, 5, 17, 7, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 6, 13, 19, 13, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 6, 21, 2, 7, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 6, 27, 16, 38, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 7, 5, 6, 37, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 7, 13, 10, 20, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 7, 20, 9, 14, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 7, 27, 0, 22, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 8, 3, 21, 16, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 8, 11, 22, 58, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 8, 18, 16, 2, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 8, 25, 10, 58, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 9, 2, 12, 56, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 9, 10, 9, 10, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 9, 16, 23, 45, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 9, 24, 1, 0, 16),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 10, 2, 5, 5, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 10, 9, 17, 28, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 10, 16, 9, 16, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 10, 23, 18, 31, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 10, 31, 20, 50, 13),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 11, 8, 0, 48, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 11, 14, 21, 7, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 11, 22, 14, 55, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 11, 30, 11, 21, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 12, 7, 8, 16, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 12, 14, 11, 27, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 12, 22, 12, 38, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2107, 12, 30, 0, 17, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 1, 5, 16, 53, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 1, 13, 4, 6, 45),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 1, 21, 9, 22, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 1, 28, 11, 49, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 2, 4, 3, 20, 50),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 2, 11, 22, 28, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 2, 20, 2, 59, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 2, 26, 22, 16, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 3, 4, 15, 52, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 3, 12, 17, 20, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 3, 20, 16, 27, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 3, 27, 7, 58, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 4, 3, 6, 24, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 4, 11, 11, 3, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 4, 19, 1, 58, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 4, 25, 17, 11, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 5, 2, 22, 38, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 5, 11, 2, 16, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 5, 18, 8, 34, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 5, 25, 2, 22, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 6, 1, 16, 1, 45),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 6, 9, 14, 32, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 6, 16, 13, 32, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 6, 23, 12, 15, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 7, 1, 9, 42, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 7, 9, 0, 21, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 7, 15, 18, 16, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 7, 22, 23, 44, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 7, 31, 2, 37, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 8, 7, 8, 42, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 8, 14, 0, 4, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 8, 21, 13, 31, 20),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 8, 29, 17, 58, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 9, 5, 16, 40, 48),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 9, 12, 8, 14, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 9, 20, 5, 37, 12),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 9, 28, 7, 21, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 10, 5, 1, 5, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 10, 11, 19, 53, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 10, 19, 23, 12, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 10, 27, 18, 50, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 11, 3, 10, 31, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 11, 10, 11, 41, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 11, 18, 16, 55, 15),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 11, 26, 4, 45, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 12, 2, 21, 21, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 12, 10, 7, 23, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 12, 18, 9, 31, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2108, 12, 25, 13, 30, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 1, 1, 10, 1, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 1, 9, 5, 21, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 1, 17, 0, 23, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 1, 23, 21, 39, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 1, 31, 0, 47, 42),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 2, 8, 3, 7, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 2, 15, 13, 20, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 2, 22, 5, 57, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 3, 1, 17, 28, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 3, 9, 22, 26, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 3, 17, 0, 21, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 3, 23, 15, 15, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 3, 31, 11, 4, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 4, 8, 14, 5, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 4, 15, 9, 34, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 4, 22, 2, 16, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 4, 30, 4, 13, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 5, 8, 1, 52, 33),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 5, 14, 17, 28, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 5, 21, 15, 27, 19),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 5, 29, 19, 48, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 6, 6, 10, 16, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 6, 13, 0, 54, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 6, 20, 6, 42, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 6, 28, 9, 24, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 7, 5, 16, 11, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 7, 12, 9, 2, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 7, 19, 23, 30, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 7, 27, 21, 12, 55),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 8, 3, 20, 48, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 8, 10, 19, 2, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 8, 18, 17, 3, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 8, 26, 7, 42, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 9, 2, 1, 36, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 9, 9, 7, 41, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 9, 17, 10, 35, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 9, 24, 17, 23, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 10, 1, 8, 10, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 10, 8, 23, 10, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 10, 17, 3, 22, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 10, 24, 2, 44, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 10, 30, 17, 55, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 11, 7, 16, 51, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 11, 15, 18, 37, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 11, 22, 12, 18, 40),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 11, 29, 7, 44, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 12, 7, 11, 37, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 12, 15, 7, 38, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 12, 21, 22, 40, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2109, 12, 29, 1, 29, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 1, 6, 6, 10, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 1, 13, 18, 7, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 1, 20, 10, 17, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 1, 27, 21, 55, 40),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 2, 4, 23, 12, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 2, 12, 2, 24, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 2, 18, 23, 22, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 2, 26, 19, 9, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 3, 6, 13, 44, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 3, 13, 9, 29, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 3, 20, 13, 43, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 3, 28, 15, 19, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 4, 5, 1, 19, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 4, 11, 16, 34, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 4, 19, 4, 53, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 4, 27, 8, 56, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 5, 4, 10, 18, 31),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 5, 11, 0, 46, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 5, 18, 20, 21, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 5, 26, 23, 8, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 6, 2, 17, 35, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 6, 9, 10, 48, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 6, 17, 11, 45, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 6, 25, 9, 46, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 7, 2, 0, 21, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 7, 8, 23, 8, 14),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 7, 17, 2, 40, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 7, 24, 17, 24, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 7, 31, 7, 45, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 8, 7, 13, 54, 1),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 8, 15, 16, 43, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 8, 22, 23, 9, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 8, 29, 16, 45, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 9, 6, 7, 0, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 9, 14, 5, 33, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 9, 21, 4, 25, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 9, 28, 4, 3, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 10, 6, 1, 57, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 10, 13, 17, 8, 24),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 10, 20, 10, 41, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 10, 27, 18, 5, 16),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 11, 4, 21, 34, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 11, 12, 3, 52, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 11, 18, 19, 13, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 11, 26, 10, 55, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 12, 4, 16, 9, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 12, 11, 14, 20, 4),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 12, 18, 6, 49, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2110, 12, 26, 5, 57, 24),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 1, 3, 8, 9, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 1, 10, 1, 1, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 1, 16, 21, 39, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 1, 25, 1, 45, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 2, 1, 20, 47, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 2, 8, 12, 4, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 2, 15, 15, 19, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 2, 23, 20, 17, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 3, 3, 6, 16, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 3, 9, 23, 24, 9),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 3, 17, 10, 47, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 3, 25, 11, 57, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 4, 1, 13, 27, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 4, 8, 11, 3, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 4, 16, 6, 38, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 4, 24, 0, 16, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 4, 30, 19, 29, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 5, 7, 23, 23, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 5, 16, 1, 12, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 5, 23, 9, 49, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 5, 30, 1, 30, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 6, 6, 12, 47, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 6, 14, 17, 14, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 6, 21, 17, 36, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 6, 28, 8, 36, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 7, 6, 3, 28, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 7, 14, 6, 15, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 7, 21, 0, 40, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 7, 27, 17, 51, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 8, 4, 19, 1, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 8, 12, 16, 31, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 8, 19, 7, 56, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 8, 26, 6, 10, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 9, 3, 10, 40, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 9, 11, 0, 48, 11),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 9, 17, 16, 11, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 9, 24, 22, 4, 39),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 10, 3, 1, 36, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 10, 10, 7, 59, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 10, 17, 2, 13, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 10, 24, 17, 16, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 11, 1, 15, 29, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 11, 8, 15, 1, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 11, 15, 14, 51, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 11, 23, 14, 21, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 12, 1, 4, 25, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 12, 7, 22, 49, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 12, 15, 6, 33, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 12, 23, 11, 11, 43),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2111, 12, 30, 16, 33, 57),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 1, 6, 8, 16, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 1, 14, 0, 56, 19),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 1, 22, 5, 50, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 1, 29, 3, 54, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 2, 4, 20, 5, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 2, 12, 20, 29, 54),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 2, 20, 21, 6, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 2, 27, 14, 20, 32),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 3, 5, 10, 33, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 3, 13, 15, 12, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 3, 21, 8, 41, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 3, 27, 23, 57, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 4, 4, 3, 21, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 4, 12, 7, 35, 14),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 4, 19, 16, 57, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 4, 26, 9, 20, 19),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 5, 3, 21, 27, 31),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 5, 11, 21, 8, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 5, 18, 22, 46, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 5, 25, 19, 21, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 6, 2, 15, 33, 13),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 6, 10, 8, 9, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 6, 17, 3, 25, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 6, 24, 6, 49, 10),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 7, 2, 8, 35, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 7, 9, 17, 14, 30),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 7, 16, 8, 25, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 7, 23, 20, 8, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 7, 31, 23, 58, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 8, 8, 1, 6, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 8, 14, 15, 18, 40),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 8, 22, 11, 10, 50),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 8, 30, 13, 32, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 9, 6, 8, 34, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 9, 13, 1, 25, 27),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 9, 21, 3, 24, 28),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 9, 29, 1, 14, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 10, 5, 16, 35, 8),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 10, 12, 15, 33, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 10, 20, 20, 8, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 10, 28, 11, 9, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 11, 4, 2, 5, 38),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 11, 11, 9, 37, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 11, 19, 12, 40, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 11, 26, 19, 37, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 12, 3, 13, 54, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 12, 11, 6, 28, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 12, 19, 4, 16, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2112, 12, 26, 3, 23, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 1, 2, 4, 20, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 1, 10, 4, 16, 52),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 1, 17, 18, 14, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 1, 24, 11, 28, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 1, 31, 20, 57, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 2, 9, 0, 59, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 2, 16, 6, 8, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 2, 22, 20, 55, 34),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 3, 2, 14, 44, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 3, 10, 18, 49, 59),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 3, 17, 16, 4, 38),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 3, 24, 8, 20, 1),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 4, 1, 8, 29, 23),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 4, 9, 8, 42, 38),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 4, 16, 0, 39, 34),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 4, 22, 21, 46, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 5, 1, 1, 12, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 5, 8, 18, 30, 37),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 5, 15, 8, 44, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 5, 22, 12, 53, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 5, 30, 16, 10, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 6, 7, 1, 1, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 6, 13, 17, 14, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 6, 21, 5, 16, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 6, 29, 4, 58, 48),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 7, 6, 5, 39, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 7, 13, 2, 53, 52),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 7, 20, 22, 24, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 7, 28, 15, 38, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 8, 4, 10, 1, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 8, 11, 14, 20, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 8, 19, 15, 44, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 8, 27, 0, 42, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 9, 2, 15, 42, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 9, 10, 4, 0, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 9, 18, 8, 25, 38),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 9, 25, 9, 4, 26),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 10, 2, 0, 4, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 10, 9, 20, 4, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 10, 17, 23, 34, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 10, 24, 17, 47, 37),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 10, 31, 12, 0, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 11, 8, 14, 5, 49),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 11, 16, 12, 32, 14),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 11, 23, 3, 40, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 11, 30, 3, 49, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 12, 8, 8, 53, 12),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 12, 15, 23, 13, 27),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 12, 22, 15, 3, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2113, 12, 29, 23, 5, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 1, 7, 2, 43, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 1, 14, 8, 7, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 1, 21, 3, 54, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 1, 28, 20, 34, 30),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 2, 5, 18, 11, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 2, 12, 16, 3, 30),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 2, 19, 18, 1, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 2, 27, 18, 10, 55),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 3, 7, 6, 50, 29),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 3, 13, 23, 54, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 3, 21, 9, 16, 33),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 3, 29, 13, 38, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 4, 5, 17, 3, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 4, 12, 8, 26, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 4, 20, 1, 24, 6),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 4, 28, 5, 25, 58),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 5, 5, 1, 35, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 5, 11, 18, 15, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 5, 19, 17, 47, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 5, 27, 17, 12, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 6, 3, 9, 10, 23),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 6, 10, 5, 56, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 6, 18, 9, 29, 53),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 6, 26, 1, 35, 34),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 7, 2, 16, 34, 20),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 7, 9, 19, 54, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 7, 17, 23, 41, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 7, 25, 7, 44, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 8, 1, 0, 36, 26),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 8, 8, 12, 14, 42),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 8, 16, 12, 5, 36),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 8, 23, 12, 55, 18),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 8, 30, 10, 15, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 9, 7, 6, 24, 23),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 9, 14, 23, 5, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 9, 21, 18, 24, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 9, 28, 22, 31, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 10, 7, 1, 13, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 10, 14, 9, 24, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 10, 21, 1, 27, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 10, 28, 14, 0, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 11, 5, 19, 19, 35),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 11, 12, 19, 43, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 11, 19, 11, 10, 57),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 11, 27, 8, 22, 8),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 12, 5, 11, 34, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 12, 12, 6, 19, 41),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 12, 19, 0, 26, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2114, 12, 27, 4, 5, 35),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 1, 4, 1, 19, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 1, 10, 17, 12, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 1, 17, 17, 25, 44),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 1, 25, 23, 7, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 2, 2, 12, 21, 32),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 2, 9, 4, 25, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 2, 16, 13, 15, 17),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 2, 24, 15, 56, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 3, 3, 20, 57, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 3, 10, 16, 14, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 3, 18, 10, 3, 32),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 3, 26, 5, 56, 41),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 4, 2, 3, 48, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 4, 9, 5, 5, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 4, 17, 5, 45, 13),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 4, 24, 17, 14, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 5, 1, 9, 59, 39),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 5, 8, 19, 10, 9),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 5, 16, 22, 54, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 5, 24, 2, 17, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 5, 30, 16, 47, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 6, 7, 10, 9, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 6, 15, 13, 1, 2),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 6, 22, 9, 43, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 6, 29, 1, 26, 12),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 7, 7, 1, 27, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 7, 15, 0, 11, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 7, 21, 16, 25, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 7, 28, 12, 51, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 8, 5, 16, 25, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 8, 13, 8, 55, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 8, 19, 23, 30, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 8, 27, 3, 30, 15),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 9, 4, 6, 48, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 9, 11, 15, 52, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 9, 18, 8, 11, 1),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 9, 25, 21, 4, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 10, 3, 20, 29, 4),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 10, 10, 22, 1, 46),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 10, 17, 19, 31, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 10, 25, 16, 41, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 11, 2, 9, 26, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 11, 9, 4, 35, 47),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 11, 16, 10, 4, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 11, 24, 12, 59, 48),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 12, 1, 21, 36, 3),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 12, 8, 12, 53, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 12, 16, 3, 27, 59),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 12, 24, 8, 24, 59),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2115, 12, 31, 8, 52, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 1, 7, 0, 0, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 1, 14, 22, 33, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 1, 23, 1, 23, 22),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 1, 29, 19, 25, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 2, 5, 14, 16, 15),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 2, 13, 17, 48, 21),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 2, 21, 14, 48, 52),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 2, 28, 5, 34, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 3, 6, 7, 10, 24),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 3, 14, 11, 46, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 3, 22, 0, 30, 7),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 3, 28, 15, 50, 40),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 4, 5, 1, 33, 23),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 4, 13, 3, 19, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 4, 20, 7, 13, 17),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 4, 27, 2, 38, 51),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 5, 4, 20, 10, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 5, 12, 15, 56, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 5, 19, 12, 20, 41),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 5, 26, 14, 18, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 6, 3, 14, 1, 25),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 6, 11, 1, 44, 6),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 6, 17, 17, 25, 18),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 6, 25, 3, 2, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 7, 3, 6, 17, 8),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 7, 10, 9, 29, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 7, 16, 23, 52, 43),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 7, 24, 17, 2, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 8, 1, 20, 22, 53),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 8, 8, 16, 22, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 8, 15, 8, 51, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 8, 23, 8, 18, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 8, 31, 8, 3, 33),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 9, 6, 23, 36, 43),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 9, 13, 21, 6, 5),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 9, 22, 0, 30, 55),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 9, 29, 17, 32, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 10, 6, 8, 15, 53),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 10, 13, 12, 57, 26),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 10, 21, 16, 52, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 10, 29, 1, 29, 31),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 11, 4, 19, 1, 22),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 11, 12, 8, 9, 37),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 11, 20, 8, 22, 2),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 11, 27, 8, 55, 54),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 12, 4, 8, 10, 18),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 12, 12, 5, 36, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 12, 19, 22, 18, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2116, 12, 26, 16, 55, 10),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 1, 2, 23, 40, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 1, 11, 3, 14, 21),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 1, 18, 10, 35, 27),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 1, 25, 2, 18, 35),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 2, 1, 17, 9, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 2, 9, 22, 40, 58),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 2, 16, 21, 29, 44),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 2, 23, 13, 33, 56),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 3, 3, 11, 46, 16),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 3, 11, 14, 16, 19),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 3, 18, 7, 23, 52),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 3, 25, 2, 47, 28),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 4, 2, 6, 5, 37),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 4, 10, 1, 39, 2),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 4, 16, 16, 36, 35),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 4, 23, 17, 52, 9),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 5, 1, 22, 34, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 5, 9, 9, 31, 0),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 5, 16, 1, 30, 56),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 5, 23, 10, 28, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 5, 31, 12, 16, 0),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 6, 7, 15, 5, 20),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 6, 14, 10, 44, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 6, 22, 3, 59, 22),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 6, 29, 23, 14, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 7, 6, 19, 43, 53),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 7, 13, 21, 10, 58),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 7, 21, 21, 26, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 7, 29, 8, 17, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 8, 5, 0, 48, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 8, 12, 9, 42, 0),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 8, 20, 13, 51, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 8, 27, 16, 29, 13),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 9, 3, 7, 36, 49),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 9, 11, 0, 44, 21),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 9, 19, 4, 32, 42),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 9, 26, 0, 46, 47),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 10, 2, 17, 23, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 10, 10, 17, 54, 18),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 10, 18, 17, 18, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 10, 25, 9, 49, 15),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 11, 1, 7, 6, 44),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 11, 9, 11, 58, 22),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 11, 17, 4, 16, 41),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 11, 23, 20, 1, 30),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 12, 1, 1, 0, 28),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 12, 9, 5, 28, 50),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 12, 16, 13, 44, 51),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 12, 23, 7, 45, 3),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2117, 12, 30, 22, 7, 36),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 1, 7, 21, 24, 59),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 1, 14, 22, 10, 16),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 1, 21, 21, 21, 27),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 1, 29, 20, 17, 25),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 2, 6, 11, 22, 43),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 2, 13, 6, 12, 11),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 2, 20, 12, 57, 2),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 2, 28, 16, 59, 50),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 3, 7, 23, 17, 57),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 3, 14, 14, 40, 36),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 3, 22, 5, 59, 44),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 3, 30, 10, 30, 29),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 4, 6, 9, 15, 29),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 4, 13, 0, 27, 4),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 4, 20, 23, 18, 36),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 4, 29, 0, 11, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 5, 5, 17, 34, 32),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 5, 12, 12, 11, 26),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 5, 20, 15, 37, 25),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 5, 28, 10, 13, 3),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 6, 4, 0, 57, 28),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 6, 11, 2, 9, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 6, 19, 6, 11, 31),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 6, 26, 17, 17, 46),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 7, 3, 8, 28, 11),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 7, 10, 18, 6, 3),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 7, 18, 18, 56, 17),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 7, 25, 22, 28, 4),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 8, 1, 17, 19, 42),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 8, 9, 11, 22, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 8, 17, 6, 12, 7),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 8, 24, 3, 3, 56),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 8, 31, 4, 34, 39),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 9, 8, 5, 11, 29),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 9, 15, 16, 26, 58),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 9, 22, 8, 37, 9),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 9, 29, 18, 43, 49),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 10, 7, 22, 44, 0),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 10, 15, 2, 8, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 10, 21, 16, 40, 6),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 10, 29, 11, 32, 34),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 11, 6, 15, 11, 6),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 11, 13, 11, 43, 51),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 11, 20, 4, 24, 55),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 11, 28, 6, 5, 5),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 12, 6, 5, 41, 49),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 12, 12, 21, 44, 39),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 12, 19, 20, 15, 8),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2118, 12, 28, 1, 3, 10),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2119, 1, 4, 17, 38, 20),
        phase: "LastQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2119, 1, 11, 8, 41, 14),
        phase: "NewMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2119, 1, 18, 15, 26, 54),
        phase: "FirstQuarter"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2119, 1, 26, 19, 4, 25),
        phase: "FullMoon"
    },
    {
        time: $470ca43ad33fe47d$var$createMomentFromDateTimeData(2119, 2, 3, 2, 59, 2),
        phase: "LastQuarter"
    }
];
var $470ca43ad33fe47d$export$2e2bcd8739ae039 = $470ca43ad33fe47d$var$GetMoonPhaseByDay;



var $45fvw = parcelRequire("45fvw");
/***
 * Get data from url without cache
 */ async function $6bba87af95d43f47$var$getDataNoCache(url) {
    console.log('Fetching fresh data (no cache)');
    var result = await fetch(url);
    return result.text();
}
/***
 * Get data from cache or from url and store to cache
 */ async function $6bba87af95d43f47$var$getData(url) {
    const cacheName = `straumsnu-v.1`;
    let cachedData = await $6bba87af95d43f47$var$getCachedData(cacheName, url);
    if (cachedData) {
        console.log('Retrieved cached data');
        return cachedData;
    }
    console.log('Fetching fresh data');
    const cacheStorage = await caches.open(cacheName);
    await cacheStorage.add(url);
    cachedData = await $6bba87af95d43f47$var$getCachedData(cacheName, url);
    await $6bba87af95d43f47$var$deleteOldCaches(cacheName);
    return cachedData;
}
// Get data from the cache.
async function $6bba87af95d43f47$var$getCachedData(cacheName, url) {
    const cacheStorage = await caches.open(cacheName);
    const cachedResponse = await cacheStorage.match(url);
    if (!cachedResponse || !cachedResponse.ok) return false;
    return await cachedResponse.text();
}
// Delete any old caches to respect user's disk space.
async function $6bba87af95d43f47$var$deleteOldCaches(currentCache) {
    const keys = await caches.keys();
    for (const key of keys){
        const isOurCache = 'straumsnu-' === key.substring(0, 6);
        if (currentCache === key || !isOurCache) continue;
        caches.delete(key);
    }
}
var $6bba87af95d43f47$export$2e2bcd8739ae039 = $6bba87af95d43f47$var$getData;


function $64b81593a164f7dc$var$parseXml(xml) {
    var dom = null;
    if (window.DOMParser) try {
        dom = new DOMParser().parseFromString(xml, "text/xml");
    } catch (e) {
        dom = null;
    }
    else if (window.ActiveXObject) try {
        dom = new ActiveXObject('Microsoft.XMLDOM');
        dom.async = false;
        if (!dom.loadXML(xml)) window.alert(dom.parseError.reason + dom.parseError.srcText);
    } catch (e) {
        dom = null;
    }
    else alert("cannot parse xml string!");
    return dom;
}
function $64b81593a164f7dc$var$xml2json(xml, tab) {
    var X = {
        toObj: function(xml) {
            var o = {};
            if (xml.nodeType == 1) {
                if (xml.attributes.length) for(var i = 0; i < xml.attributes.length; i++)o[xml.attributes[i].nodeName] = (xml.attributes[i].nodeValue || "").toString();
                if (xml.firstChild) {
                    var textChild = 0, cdataChild = 0, hasElementChild = false;
                    for(var n = xml.firstChild; n; n = n.nextSibling){
                        if (n.nodeType == 1) hasElementChild = true;
                        else if (n.nodeType == 3 && n.nodeValue.match(/[^ \f\n\r\t\v]/)) textChild++; // non-whitespace text
                        else if (n.nodeType == 4) cdataChild++; // cdata section node
                    }
                    if (hasElementChild) {
                        if (textChild < 2 && cdataChild < 2) {
                            X.removeWhite(xml);
                            for(var n = xml.firstChild; n; n = n.nextSibling){
                                if (n.nodeType == 3) o["#text"] = X.escape(n.nodeValue);
                                else if (n.nodeType == 4) o["#cdata"] = X.escape(n.nodeValue);
                                else if (o[n.nodeName]) {
                                    if (o[n.nodeName] instanceof Array) o[n.nodeName][o[n.nodeName].length] = X.toObj(n);
                                    else o[n.nodeName] = [
                                        o[n.nodeName],
                                        X.toObj(n)
                                    ];
                                } else o[n.nodeName] = X.toObj(n);
                            }
                        } else if (!xml.attributes.length) o = X.escape(X.innerXml(xml));
                        else o["#text"] = X.escape(X.innerXml(xml));
                    } else if (textChild) {
                        if (!xml.attributes.length) o = X.escape(X.innerXml(xml));
                        else o["#text"] = X.escape(X.innerXml(xml));
                    } else if (cdataChild) {
                        if (cdataChild > 1) o = X.escape(X.innerXml(xml));
                        else for(var n = xml.firstChild; n; n = n.nextSibling)o["#cdata"] = X.escape(n.nodeValue);
                    }
                }
                if (!xml.attributes.length && !xml.firstChild) o = null;
            } else if (xml.nodeType == 9) o = X.toObj(xml.documentElement);
            else alert("unhandled node type: " + xml.nodeType);
            return o;
        },
        toJson: function(o, name, ind) {
            var json = name ? "\"" + name + "\"" : "";
            if (o instanceof Array) {
                for(var i = 0, n = o.length; i < n; i++)o[i] = X.toJson(o[i], "", ind + "\t");
                json += (name ? ":[" : "[") + (o.length > 1 ? "\n" + ind + "\t" + o.join(",\n" + ind + "\t") + "\n" + ind : o.join("")) + "]";
            } else if (o == null) json += (name && ":") + "null";
            else if (typeof o == "object") {
                var arr = [];
                for(var m in o)arr[arr.length] = X.toJson(o[m], m, ind + "\t");
                json += (name ? ":{" : "{") + (arr.length > 1 ? "\n" + ind + "\t" + arr.join(",\n" + ind + "\t") + "\n" + ind : arr.join("")) + "}";
            } else if (typeof o == "string") json += (name && ":") + "\"" + o.toString() + "\"";
            else json += (name && ":") + o.toString();
            return json;
        },
        innerXml: function(node) {
            var s = "";
            if ("innerHTML" in node) s = node.innerHTML;
            else {
                var asXml = function(n) {
                    var s = "";
                    if (n.nodeType == 1) {
                        s += "<" + n.nodeName;
                        for(var i = 0; i < n.attributes.length; i++)s += " " + n.attributes[i].nodeName + "=\"" + (n.attributes[i].nodeValue || "").toString() + "\"";
                        if (n.firstChild) {
                            s += ">";
                            for(var c = n.firstChild; c; c = c.nextSibling)s += asXml(c);
                            s += "</" + n.nodeName + ">";
                        } else s += "/>";
                    } else if (n.nodeType == 3) s += n.nodeValue;
                    else if (n.nodeType == 4) s += "<![CDATA[" + n.nodeValue + "]]>";
                    return s;
                };
                for(var c = node.firstChild; c; c = c.nextSibling)s += asXml(c);
            }
            return s;
        },
        escape: function(txt) {
            return txt.replace(/[\\]/g, "\\\\").replace(/[\"]/g, '\\"').replace(/[\n]/g, '\\n').replace(/[\r]/g, '\\r');
        },
        removeWhite: function(e) {
            e.normalize();
            for(var n = e.firstChild; n;){
                if (n.nodeType == 3) {
                    if (!n.nodeValue.match(/[^ \f\n\r\t\v]/)) {
                        var nxt = n.nextSibling;
                        e.removeChild(n);
                        n = nxt;
                    } else n = n.nextSibling;
                } else if (n.nodeType == 1) {
                    X.removeWhite(n);
                    n = n.nextSibling;
                } else n = n.nextSibling;
            }
            return e;
        }
    };
    if (xml.nodeType == 9) xml = xml.documentElement;
    var json = X.toJson(X.toObj(X.removeWhite(xml)), xml.nodeName, "\t");
    return "{\n" + tab + (tab ? json.replace(/\t/g, tab) : json.replace(/\t|\n/g, "")) + "\n}";
}
function $64b81593a164f7dc$var$xmlText2json(xml) {
    const parser = new DOMParser();
    const dom = parser.parseFromString(xml, "application/xml");
    return $64b81593a164f7dc$var$xml2json(dom, "  ");
}
var $64b81593a164f7dc$export$2e2bcd8739ae039 = $64b81593a164f7dc$var$xmlText2json;


/** Get astronomically predicted low / high tide level objects from kartverket.no for a period
 * @returns an array of objects with properties
 *      { @property {number} value         - sea level at high/low tide
 *        @property {moment} time          - time of high/low tide
 *        @property {string} flag          - "high" or "low"
 *        @property {moment} shiftedTime   - time + parameter shiftMinutes
 *        @property {number} diff          - value difference from previous level
 *        @property {number} utcOffsetDiff - utcOffset difference from previous level (60 or -60)
 *       }
 * @param {moment} fromTime Period of interest's start time
 * @param {number} days Period length in days 
 * @param {number} shiftMinutes minutes to add to get shifted time
 */ async function $9c238bf50a7726a0$var$getShiftedLevels(from, days, shiftMinutes) {
    // period of interest
    const to = from.clone().add(days, 'd');
    // minimum period to get is one day earlier (for diff on first level)
    const getMinimumFrom = from.clone().add(-1, 'd');
    const getMinimumTo = to.clone().add(1, 'd');
    // period to get/cache: Rounded to month 
    const getFrom = getMinimumFrom.clone().startOf('month');
    const getTo = getMinimumTo.clone().endOf('month');
    const url = `https://vannstand.kartverket.no/tideapi.php?lat=67.288290&lon=14.390813&fromtime=${getFrom.format()}&totime=${getTo.format()}&datatype=tab&refcode=cd&place=&file=&lang=nb&interval=10&dst=1&tzone=&tide_request=locationdata`;
    console.log("Period of interest : ", from.format(), to.format());
    console.log("Period to get/cache: ", getFrom.format(), getTo.format());
    const data = await (0, $6bba87af95d43f47$export$2e2bcd8739ae039)(url).then((xmlText)=>(0, $64b81593a164f7dc$export$2e2bcd8739ae039)(xmlText)).then((json)=>$9c238bf50a7726a0$var$extractLevelsFromJsonObject(json)).then((levels)=>$9c238bf50a7726a0$var$shiftLevels(levels, shiftMinutes)).then((shiftedLevels)=>shiftedLevels.filter((lev)=>lev.shiftedTime.isAfter(from) && lev.shiftedTime.isBefore(to)));
    return data;
}
function $9c238bf50a7726a0$var$extractLevelsFromJsonObject(json) {
    if (!json) throw "no JSON data";
    return JSON.parse(json).tide.locationdata.data.waterlevel;
}
function $9c238bf50a7726a0$var$shiftLevels(levels, shiftMinutes) {
    return levels.map((level, index, array)=>{
        const _shiftedTime = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(level.time).add(shiftMinutes, 'm');
        const _utcOffsetDiff = index > 0 ? _shiftedTime.utcOffset() - (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(array[index - 1].time).add(shiftMinutes, 'm').utcOffset() : 0;
        return {
            value: level.value,
            time: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(level.time),
            shiftedTime: _shiftedTime,
            flag: level.flag,
            diff: index > 0 ? level.value - array[index - 1].value : null,
            utcOffsetDiff: _utcOffsetDiff
        };
    });
}
var $9c238bf50a7726a0$export$2e2bcd8739ae039 = $9c238bf50a7726a0$var$getShiftedLevels;


var $e4d35771c76ea505$exports = {};
$e4d35771c76ea505$exports = import.meta.resolve("5AKkO");


var $9fed59a31deb1223$exports = {};
$9fed59a31deb1223$exports = import.meta.resolve("5Uu6A");


var $1b1d80f39a59b748$exports = {};
$1b1d80f39a59b748$exports = import.meta.resolve("ciNJX");


var $695b96f928b5a41e$exports = {};
$695b96f928b5a41e$exports = import.meta.resolve("cszjf");


const $93fec0c656ef319b$var$moonImages = {
    NewMoon: (0, (/*@__PURE__*/$parcel$interopDefault($e4d35771c76ea505$exports))),
    FullMoon: (0, (/*@__PURE__*/$parcel$interopDefault($9fed59a31deb1223$exports))),
    FirstQuarter: (0, (/*@__PURE__*/$parcel$interopDefault($1b1d80f39a59b748$exports))),
    LastQuarter: (0, (/*@__PURE__*/$parcel$interopDefault($695b96f928b5a41e$exports)))
};
function $93fec0c656ef319b$export$f66b53a1991deef8(header) {
    header.innerHTML = `
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a  id="btnHome" class="navbar-brand" href="#">N\xe5r snur Saltstraumen?</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
           <li class="nav-item"><a href="/Home/Today" class="nav-link">I dag</a></li>
           <li class="nav-item"><a href="/Home/About" class="nav-link">Om</a></li>
           <li class="nav-item"><a href="/Home/Contact" class="nav-link">Kontakt</a></li>
      </ul>
    </div>
  </div>
</nav>`;
}
function $93fec0c656ef319b$export$5e5c8210e5686582(container) {
    $93fec0c656ef319b$var$renderControls(container);
    $93fec0c656ef319b$var$renderDayTable(container);
}
function $93fec0c656ef319b$var$renderControls(container) {
    container.innerHTML = `
    <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups" style="margin-bottom:15px;">
            <div class="btn-group mr-2" role="group" aria-label="First group">
                <button button="" id="previousSaturday" type="button" class="btn btn-light btn-sm" data-toggle="tooltip" data-placement="top"
                    title="Sist l\xf8rdag">
                    &lt;
                </button>
            </div>
            <div class="input-group mr-2">
                <div class="input-group">
                    <input id="dpicker" type="date" class="form-control form-control-sm" >
                </div>
            </div>
            <div class="btn-group mr-2" role="group" aria-label="Second group">
                <button button="" id="nextSaturday" type="button" class="btn btn-light btn-sm" data-toggle="tooltip" data-placement="top"
                    title="Kommende l\xf8rdag" >
                    &gt;
                </button>
            </div>
        </div>
`;
}
function $93fec0c656ef319b$var$renderDayTable(container) {
    container.innerHTML += `
        <div>
            <table class="table w-auto">
                <thead>
                    <tr>
                        <th style="background-color: aliceblue;">Dato</th>
                        <th style="background-color: aliceblue;">Bod\xf8</th>
                        <th style="background-color: aliceblue;"></th>
                        <th style="background-color: aliceblue;">Till</th>
                        <th style="background-color: aliceblue;">Snur</th>
                        <th style="background-color: aliceblue; text-align: right;">Niv\xe5</th>
                        <th style="background-color: aliceblue; text-align: right;">Diff</th>
                    </tr>
                </thead>
                <tbody id="renderElement">
                </tbody>
                <tfoot>
                    <tr><td colspan="7"><p><center>Alle klokkeslett er angitt i lokal tid for Saltstraumen</center></p></td></tr>
                </tfoot>
            </table>
        </div>`;
}
function $93fec0c656ef319b$export$28a4085e424ae3a0(container) {
    $93fec0c656ef319b$var$renderDayTable(container);
    container.innerHTML += `<p>
            <button class="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample"
                aria-expanded="false" aria-controls="collapseExample">
                Detaljer
            </button>
        </p>
        <div class="collapse" id="collapseExample">
            <div class="card card-body">
                <p>Saltstraumen snur p\xe5 flo og fj\xe6re, ca 1 time og 41 minutter etter flo og fj\xe6re i Bod\xf8. Straumsnu skjer 4 eller 3 ganger i d\xf8gnet.</p>
                <p>Tabellens f\xf8rste kolonner <strong>Dato</strong> og <strong>Bod\xf8</strong> viser beregnet dato og tidspunkt for flo og fj\xe6re i Bod\xf8.</p>
                <p>Neste kolonne <strong>Till</strong> viser tillegget p\xe5 1 time og 41 minutter. </p>
                <p>Kolonnen <strong>Snur</strong> viser beregnet tidspunkt for straumsnu. <i>NB! Beregnet tidspunkt er ikke n\xf8yaktig.</i> Det vil p\xe5virkes av bl.a. trykk og vindforhold. Selv om dette er beste gjetning, kan Saltstraumen snu oppmot en halv time f\xf8r eller etter dette tidspunktet.</p>
                <p>Kolonnen <strong>Niv\xe5</strong> viser beregnet niv\xe5 ved flo/fj\xe6re i Bod\xf8. Niv\xe5et er i cm over sj\xf8kartnull.</p>
                <p>Kolonnen <strong>Diff</strong> viser forskjellen fra forrige beregnet niv\xe5. Differansen er en god indikator p\xe5 str\xf8mmens styrke. Jo st\xf8rre absoluttverdi, jo sterkere str\xf8m.</p>
                <p>L\xf8sningen benytter data som hentes fra <a href="https://www.kartverket.no/api-og-data/tidevann-og-vannstandsdata" target="_blank">Kartverket</a>.</p>
            </div>
        </div>`;
}
function $93fec0c656ef319b$export$deb2009618433c60(daysTBodyElement) {
    const trs = daysTBodyElement.getElementsByTagName('tr');
    const trList = Array.prototype.slice.call(trs);
    trList.forEach((element)=>{
        if (element.parentNode.name != 'template') daysTBodyElement.removeChild(element);
    });
}
function $93fec0c656ef319b$export$4fcb48d6be4cc53e(daysTableBodyElement, days) {
    days.forEach((day)=>{
        const tr = document.createElement('tr');
        tr.innerHTML = `<tr rowspan="5">
                            <td rowspan="${day.levels.length + 1}" class="table-highlighted-column" style="vertical-align: top;background-color: aliceblue;">${day.dayDisplayText}${$93fec0c656ef319b$var$getMoonPhaseHTML(day.moonPhase)}</td>
                        </tr>`;
        daysTableBodyElement.appendChild(tr);
        day.levels.forEach((level)=>{
            const tr = document.createElement('tr');
            tr.innerHTML = `<tr>
                                <td>${level.flag}</td>
                                <td>${level.timeDisplayText}</td>
                                <td>${level.add}</td>
                                <td class="table-highlighted-column" style="background-color: aliceblue;">${level.shiftedTimeDisplayText}&nbsp;${level.utcOffsetDiff !== 0 ? "*" : ""}</td>
                                <td class="rightadjust">${level.level}</td>
                                <td class="rightadjust table-highlighted-column" style="background-color: aliceblue;">${level.diff}</td>
                            </tr>`;
            daysTableBodyElement.appendChild(tr);
        });
        var tr3 = document.createElement('tr');
        const utcDiffThisDay = day.levels.filter((l)=>l.utcOffsetDiff !== 0)[0];
        tr3.innerHTML = `<td colspan="7">
        ${utcDiffThisDay ? utcDiffThisDay.utcOffsetDiff === 60 ? "<i><strong>*</strong> F\xf8rste straumsnu etter bytte til sommertid. Husk \xe5 stille klokka!</i><br/>" : "<i><strong>*</strong> F\xf8rste straumsnu etter bytte tilbake til normaltid. Husk \xe5 stille klokka!</i><br/>" : ""}
            </td>`;
        daysTableBodyElement.appendChild(tr3);
        if (utcDiffThisDay) {
            tr3 = document.createElement('tr');
            tr3.innerHTML = `<td colspan="7"></td>`;
            daysTableBodyElement.appendChild(tr3);
        }
    });
}
function $93fec0c656ef319b$export$f540d788db413b50(daysTableBodyElement) {
    daysTableBodyElement.innerHTML = `<p style="font-size:larger">
    Straumsnu.no er utviklet av Dag Pedersen.<br />
    <br />
    Har du sp\xf8rsm\xe5l eller innspill? <br />
    Ta gjerne kontakt p\xe5 e-post <a href="mailto:pedersendag@gmail.com">pedersendag@gmail.com</a>.<br />
</p>`;
}
function $93fec0c656ef319b$export$432de3bf4b08ac67(daysTableBodyElement, days, state) {
    var allLevels = days[0].levels.concat(days[1].levels);
    var upcoming = allLevels.filter((a)=>a.shiftedTime > state.now);
    var next = upcoming[0];
    let newNode = document.createElement("div");
    newNode.innerHTML = `<div>
            <h5>Om tabellen</h5>
            <p style="font-size:larger">
                Det er ${state.now.format("dddd D. MMMM")}, og klokka er ${state.now.format("HH:mm")}.<br />
            </p>
            <p style="font-size:larger">
                Tabellen viser at neste straumsnu er ved <strong>${next.flag === "Flo" ? "flo" : "fj\xe6re"}</strong> sj\xf8
                ${next.shiftedTime.startOf('day').isSame(state.now.startOf('day')) ? "" : "i morgen"} 
                klokka <strong>${next.shiftedTimeDisplayText}</strong>.<br/>
                Niv\xe5et vil da v\xe6re ${next.level} cm, <strong>${Math.abs(next.diff)} </strong> ${next.diff > 0 ? "h\xf8yere" : "lavere"} enn ved ${next.flag === "Flo" ? "fj\xe6re" : "flo"}.
            </p>
        </div>`;
    var tbl = daysTableBodyElement.parentNode;
    var tblprnt = tbl.parentNode;
    tblprnt.insertBefore(newNode, tbl);
    days.forEach((day, index)=>{
        if (index === 0 || day.levels[index].shiftedTime.startOf('day').isSame(next.shiftedTime.startOf('day'))) {
            var tr = document.createElement('tr');
            tr.innerHTML = `<tr rowspan="5">
                            <td rowspan="${day.levels.length + 1}" class="table-highlighted-column" style="vertical-align: top;background-color: aliceblue;">${day.dayDisplayText}${$93fec0c656ef319b$var$getMoonPhaseHTML(day.moonPhase)}</td>
                        </tr>`;
            daysTableBodyElement.appendChild(tr);
            day.levels.forEach((level)=>{
                tr = document.createElement('tr');
                tr.innerHTML = `<tr>
                                <td class="${level == next ? 'rowHighlight-left' : ''}">${level.flag}</td>
                                <td class="${level == next ? 'rowHighlight-middle' : ''}">${level.timeDisplayText}</td>
                                <td class="${level == next ? 'rowHighlight-middle' : ''}">${level.add}</td>
                                <td class="table-highlighted-column ${level == next ? 'rowHighlight-middle' : ''}" style="background-color: aliceblue;">${level.shiftedTimeDisplayText}
                                ${level.utcOffsetDiff !== 0 ? "*" : ""}</td>
                                <td class="rightadjust ${level == next ? 'rowHighlight-middle' : ''}">${level.level}</td>
                                <td class="rightadjust table-highlighted-column ${level == next ? 'rowHighlight-right' : ''}" style="background-color: aliceblue;">${level.diff}</td>
                            </tr>`;
                daysTableBodyElement.appendChild(tr);
            });
            const tr3 = document.createElement('tr');
            tr3.innerHTML = `<td colspan="7"></td>`;
            daysTableBodyElement.appendChild(tr3);
        }
    });
}
function $93fec0c656ef319b$var$getMoonPhaseHTML(moonPhase) {
    if (!moonPhase) return '';
    else {
        let displayText = "";
        switch(moonPhase){
            case "FirstQuarter":
                displayText = "Voksende halvveis til fullm\xe5ne";
                break;
            case "LastQuarter":
                displayText = "Minkende halvveis til nym\xe5ne";
                break;
            case "FullMoon":
                displayText = "Fullm\xe5ne";
                break;
            case "NewMoon":
                displayText = "Nym\xe5ne";
                break;
            default:
                displayText = "Invalid moonphase " + moonPhase;
                break;
        }
        return `<center><br /><br /><img width="12" height="12" Title="${displayText}" src="${$93fec0c656ef319b$var$moonImages[moonPhase] ?? ''}" alt="M\xe5nefase ${moonPhase}" /></center>`;
    }
}
function $93fec0c656ef319b$var$cap1stLetter(s) {
    return s[0].toUpperCase() + s.substr(1);
}
function $93fec0c656ef319b$export$f78842bd8df93f12(container, state) {
    const div = document.createElement('div');
    div.innerHTML = `<footer style="padding-bottom: 15px;">
        Data: <a href="https://www.kartverket.no/api-og-data/tidevann-og-vannstandsdata" target="_blank">Kartverket</a>
        <br>
        Med forbehold om feil.<br>
        <a href="mailto:pedersendag@gmail.com">Dag Pedersen</a> \xa9 2009 - 2026
    </footer>`;
    container.appendChild(div);
}


function $d2269e2341588010$var$dateChangeHandler() {
    const value1 = this.value;
    $d2269e2341588010$var$state.date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(value1);
    $d2269e2341588010$var$getAndRenderDays(7, (0, $93fec0c656ef319b$export$4fcb48d6be4cc53e));
    $d2269e2341588010$var$updateUrlFromDate();
}
function $d2269e2341588010$var$setDatePickerValue(date) {
    const picker = document.getElementById("dpicker");
    picker.value = date;
}
function $d2269e2341588010$var$GotoToday() {
    $d2269e2341588010$var$state.date = new (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))($d2269e2341588010$var$state.now).startOf('day');
    $d2269e2341588010$var$setDatePickerValue($d2269e2341588010$var$state.date.format("yyyy-MM-DD"));
    $d2269e2341588010$var$getAndRenderDays(7, (0, $93fec0c656ef319b$export$4fcb48d6be4cc53e));
    $d2269e2341588010$var$updateUrlFromDate();
}
function $d2269e2341588010$var$GotoNextSaturday() {
    const dayINeed = 6; // for saturday
    const currentDay = $d2269e2341588010$var$state.date.isoWeekday();
    if (currentDay < dayINeed) $d2269e2341588010$var$state.date = $d2269e2341588010$var$state.date.isoWeekday(dayINeed);
    else $d2269e2341588010$var$state.date = $d2269e2341588010$var$state.date.add(1, 'weeks').isoWeekday(dayINeed);
    $d2269e2341588010$var$setDatePickerValue($d2269e2341588010$var$state.date.format("yyyy-MM-DD"));
    $d2269e2341588010$var$getAndRenderDays(7, (0, $93fec0c656ef319b$export$4fcb48d6be4cc53e));
    $d2269e2341588010$var$updateUrlFromDate();
}
function $d2269e2341588010$var$GotoPreviousSaturday() {
    const dayINeed = 6; // for saturday
    const currentDay = $d2269e2341588010$var$state.date.isoWeekday();
    if (currentDay > dayINeed) $d2269e2341588010$var$state.date = $d2269e2341588010$var$state.date.isoWeekday(dayINeed);
    else $d2269e2341588010$var$state.date = $d2269e2341588010$var$state.date.add(-1, 'weeks').isoWeekday(dayINeed);
    $d2269e2341588010$var$setDatePickerValue($d2269e2341588010$var$state.date.format("yyyy-MM-DD"));
    $d2269e2341588010$var$getAndRenderDays(7, (0, $93fec0c656ef319b$export$4fcb48d6be4cc53e));
    $d2269e2341588010$var$updateUrlFromDate();
}
function $d2269e2341588010$var$setInitialState() {
    $d2269e2341588010$var$state.now = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))();
    $d2269e2341588010$var$state.date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().startOf('day');
    const params = new URLSearchParams(window.location.search);
    const nowString = params.get('now');
    const queriedNow = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(nowString);
    if (nowString !== null && queriedNow._isValid) try {
        $d2269e2341588010$var$state.now = queriedNow;
        $d2269e2341588010$var$state.date = queriedNow.startOf('day');
    } catch  {}
}
function $d2269e2341588010$var$setDateFromPath() {
    const path = window.location.pathname;
    if (path.startsWith("/Home/Index/")) {
        const datePath = path.substring(5);
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(datePath);
        if (date._isValid) $d2269e2341588010$var$state.date = date;
    }
}
var $d2269e2341588010$var$state = {
    get date () {
        return this._date;
    },
    set date (value){
        this._date = value;
    }
};
function $d2269e2341588010$var$updateUrlFromDate() {
    if (window.location.pathname.startsWith("/Home/Index")) window.history.pushState("", "", "/Home/Index/" + $d2269e2341588010$var$state.date.format("yyyy-MM-DD"));
}
function $d2269e2341588010$var$addControlsEventListeners() {
    document.getElementById("previousSaturday").addEventListener('click', $d2269e2341588010$var$GotoPreviousSaturday);
    document.getElementById("nextSaturday").addEventListener('click', $d2269e2341588010$var$GotoNextSaturday);
    document.getElementById("dpicker").addEventListener('change', $d2269e2341588010$var$dateChangeHandler);
    document.getElementById("btnHome").addEventListener('click', $d2269e2341588010$var$GotoToday);
}
function $d2269e2341588010$var$addMoonPhase(dayModels) {
    let array = [];
    dayModels.forEach(function(dayModel) {
        dayModel.moonPhase = (0, $470ca43ad33fe47d$export$2e2bcd8739ae039)(dayModel.day);
        array.push(dayModel);
    });
    return array;
}
function $d2269e2341588010$var$getAndRenderDays(dayCount, renderer) {
    var daysTableBodyElement = document.getElementById("renderElement");
    (0, $93fec0c656ef319b$export$deb2009618433c60)(daysTableBodyElement);
    (0, $9c238bf50a7726a0$export$2e2bcd8739ae039)($d2269e2341588010$var$state.date, dayCount, 101) // shift 101 minutes (1h 41 minutes)
    .then((shiftedLevels)=>(0, $d7fcaaa29d0ffaa7$export$2e2bcd8739ae039)(shiftedLevels, $d2269e2341588010$var$state.now)).then((dayModels)=>$d2269e2341588010$var$addMoonPhase(dayModels)).then((dayModelWithMoonPhase)=>renderer(daysTableBodyElement, dayModelWithMoonPhase, $d2269e2341588010$var$state)).catch((error)=>console.error('Failed fetching and rendering data: ' + error));
}

document.addEventListener('DOMContentLoaded', ()=>{
    (parcelRequire("3jH64"));
    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).locale('nb');
    var container = document.getElementById("container");
    var header = document.getElementById("header");
    (0, $93fec0c656ef319b$export$f66b53a1991deef8)(header);
    switch(window.location.pathname){
        case '/Home/About':
            $d2269e2341588010$var$setInitialState();
            (0, $93fec0c656ef319b$export$28a4085e424ae3a0)(container);
            $d2269e2341588010$var$getAndRenderDays(2, (0, $93fec0c656ef319b$export$432de3bf4b08ac67));
            (0, $93fec0c656ef319b$export$f78842bd8df93f12)(document.getElementById("container"), $d2269e2341588010$var$state);
            break;
        case '/Home/Contact':
            (0, $93fec0c656ef319b$export$f540d788db413b50)(container);
            break;
        default:
            if (!window.location.pathname.startsWith("/Home/")) window.history.pushState("", "", "/Home/Index");
            $d2269e2341588010$var$setInitialState();
            $d2269e2341588010$var$setDateFromPath();
            (0, $93fec0c656ef319b$export$5e5c8210e5686582)(container);
            $d2269e2341588010$var$setDatePickerValue($d2269e2341588010$var$state.date.format("yyyy-MM-DD"));
            $d2269e2341588010$var$addControlsEventListeners();
            $d2269e2341588010$var$getAndRenderDays(7, (0, $93fec0c656ef319b$export$4fcb48d6be4cc53e));
            (0, $93fec0c656ef319b$export$f78842bd8df93f12)(container, $d2269e2341588010$var$state);
    }
});


//# sourceMappingURL=straumsnu.js.3e2f2b76.js.map
